/* tslint:disable */
/* eslint-disable */
/**
 * inventoryManage API
 * 在庫の情報を操作するAPI
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * 
 * @export
 * @interface AggregateBusiness
 */
export interface AggregateBusiness {
    /**
     * 
     * @type {string}
     * @memberof AggregateBusiness
     */
    'organizationId'?: string;
    /**
     * 取引ID
     * @type {string}
     * @memberof AggregateBusiness
     */
    'aggregateBusinessId'?: string;
    /**
     * 置き場CD
     * @type {string}
     * @memberof AggregateBusiness
     */
    'warehouseNumber'?: string;
    /**
     * 置き場名
     * @type {string}
     * @memberof AggregateBusiness
     */
    'warehouse'?: string;
    /**
     * 仕入先CD
     * @type {string}
     * @memberof AggregateBusiness
     */
    'supplierNumber'?: string;
    /**
     * 仕入先名
     * @type {string}
     * @memberof AggregateBusiness
     */
    'supplierName'?: string;
    /**
     * 商品CD
     * @type {string}
     * @memberof AggregateBusiness
     */
    'businessNumber'?: string;
    /**
     * 商品名
     * @type {string}
     * @memberof AggregateBusiness
     */
    'businessName'?: string;
    /**
     * 容量
     * @type {number}
     * @memberof AggregateBusiness
     */
    'package'?: number;
    /**
     * 単位
     * @type {string}
     * @memberof AggregateBusiness
     */
    'unit'?: string;
    /**
     * 標準在庫指数（MIN）
     * @type {number}
     * @memberof AggregateBusiness
     */
    'standardInventoryIndexMin'?: number;
    /**
     * 標準在庫指数（MAX）
     * @type {number}
     * @memberof AggregateBusiness
     */
    'standardInventoryIndexMax'?: number;
    /**
     * 標準在庫指数（単位）
     * @type {string}
     * @memberof AggregateBusiness
     */
    'standardInventoryIndexUnit'?: string;
    /**
     * リードタイム
     * @type {number}
     * @memberof AggregateBusiness
     */
    'leadTime'?: number;
    /**
     * リードタイム単位
     * @type {string}
     * @memberof AggregateBusiness
     */
    'leadTimeUnit'?: string;
    /**
     * MQQ
     * @type {number}
     * @memberof AggregateBusiness
     */
    'moq'?: number;
    /**
     * 発注単位
     * @type {number}
     * @memberof AggregateBusiness
     */
    'orderPackage'?: number;
    /**
     * 在庫年月日
     * @type {number}
     * @memberof AggregateBusiness
     */
    'executionDate'?: number;
    /**
     * メモ
     * @type {string}
     * @memberof AggregateBusiness
     */
    'aggregateBusinessNote'?: string;
    /**
     * 入荷情報
     * @type {Array<Arrival>}
     * @memberof AggregateBusiness
     */
    'arrivals'?: Array<Arrival>;
    /**
     * 在庫情報
     * @type {Array<Inventory>}
     * @memberof AggregateBusiness
     */
    'inventories'?: Array<Inventory>;
    /**
     * 販売実績
     * @type {Array<SalesResult>}
     * @memberof AggregateBusiness
     */
    'salesResults'?: Array<SalesResult>;
    /**
     * 客先内示情報
     * @type {Array<CustomerAnnounce>}
     * @memberof AggregateBusiness
     */
    'customerAnnounces'?: Array<CustomerAnnounce>;
    /**
     * 仕入先内示情報
     * @type {Array<SupplierAnnounce>}
     * @memberof AggregateBusiness
     */
    'supplierAnnounces'?: Array<SupplierAnnounce>;
    /**
     * 発注情報
     * @type {Array<Order>}
     * @memberof AggregateBusiness
     */
    'orders'?: Array<Order>;
    /**
     * 集計取引の更新日時情報
     * @type {number}
     * @memberof AggregateBusiness
     */
    'updateAt'?: number;
    /**
     * 集計取引の作成日時情報
     * @type {number}
     * @memberof AggregateBusiness
     */
    'createAt'?: number;
    /**
     * ユーザーデータの配列
     * @type {Array<UserData>}
     * @memberof AggregateBusiness
     */
    'aggregateBusinessResponsibleUsers'?: Array<UserData>;
    /**
     * ExecutionDate時点での在庫数量
     * @type {number}
     * @memberof AggregateBusiness
     */
    'inventoryAtExecutionDate'?: number;
    /**
     * ExecutionDate時点での在庫の状態（過剰 HIGH・適正 NORMAL・不足 LOW）
     * @type {string}
     * @memberof AggregateBusiness
     */
    'inventoryConditionAtExecutionDate'?: AggregateBusinessInventoryConditionAtExecutionDateEnum;
    /**
     * シミュレーション（１つ目の発注推奨を求める）の結果：推奨発注日
     * @type {number}
     * @memberof AggregateBusiness
     */
    'recommendEstimateTime'?: number;
    /**
     * シミュレーション（１つ目の発注推奨を求める）の結果：発注数量
     * @type {number}
     * @memberof AggregateBusiness
     */
    'recommendArrivalValue'?: number;
    /**
     * 製造社
     * @type {string}
     * @memberof AggregateBusiness
     */
    'manufacturer'?: string;
    /**
     * ユーザーカスタムパラメータ（JSON文字列）
     * @type {string}
     * @memberof AggregateBusiness
     */
    'userCustomParameters'?: string | null;
}

export const AggregateBusinessInventoryConditionAtExecutionDateEnum = {
    High: 'HIGH',
    Normal: 'NORMAL',
    Low: 'LOW'
} as const;

export type AggregateBusinessInventoryConditionAtExecutionDateEnum = typeof AggregateBusinessInventoryConditionAtExecutionDateEnum[keyof typeof AggregateBusinessInventoryConditionAtExecutionDateEnum];

/**
 * 入荷情報
 * @export
 * @interface Arrival
 */
export interface Arrival {
    /**
     * 集計ID
     * @type {string}
     * @memberof Arrival
     */
    'aggregateBusinessId'?: string;
    /**
     * 入荷ID
     * @type {string}
     * @memberof Arrival
     */
    'arrivalId'?: string;
    /**
     * 入荷年
     * @type {number}
     * @memberof Arrival
     */
    'targetYear'?: number;
    /**
     * 入荷月
     * @type {number}
     * @memberof Arrival
     */
    'targetMonth'?: number;
    /**
     * 入荷数量
     * @type {number}
     * @memberof Arrival
     */
    'arrivalAmount'?: number;
}
/**
 * 入荷情報
 * @export
 * @interface ArrivalInfo
 */
export interface ArrivalInfo {
    /**
     * 集計ID
     * @type {string}
     * @memberof ArrivalInfo
     */
    'aggregateBusinessId'?: string;
    /**
     * 入荷年
     * @type {number}
     * @memberof ArrivalInfo
     */
    'targetYear'?: number;
    /**
     * 入荷月
     * @type {number}
     * @memberof ArrivalInfo
     */
    'targetMonth'?: number;
    /**
     * 入荷数量
     * @type {number}
     * @memberof ArrivalInfo
     */
    'arrivalAmount'?: number;
}
/**
 * 
 * @export
 * @interface BulkModifyArrivalRequest
 */
export interface BulkModifyArrivalRequest {
    /**
     * 入荷情報を一括で修正するAPIのリクエスト情報
     * @type {Array<ArrivalInfo>}
     * @memberof BulkModifyArrivalRequest
     */
    'bulkModifyArrivalInfo'?: Array<ArrivalInfo>;
}
/**
 * 入荷情報を一括で修正するAPIのレスポンス情報
 * @export
 * @interface BulkModifyArrivalResponse
 */
export interface BulkModifyArrivalResponse {
    /**
     * 
     * @type {number}
     * @memberof BulkModifyArrivalResponse
     */
    'statusCode': number;
    /**
     * 
     * @type {number}
     * @memberof BulkModifyArrivalResponse
     */
    'code': number;
    /**
     * 
     * @type {string}
     * @memberof BulkModifyArrivalResponse
     */
    'message': string;
    /**
     * 
     * @type {BulkModifyArrivalResponseResult}
     * @memberof BulkModifyArrivalResponse
     */
    'result': BulkModifyArrivalResponseResult;
}
/**
 * 入荷情報を一括で修正するAPIのレスポンスの型定義
 * @export
 * @interface BulkModifyArrivalResponseResult
 */
export interface BulkModifyArrivalResponseResult {
    /**
     * 
     * @type {Array<string>}
     * @memberof BulkModifyArrivalResponseResult
     */
    'arrivalIds'?: Array<string>;
}
/**
 * 
 * @export
 * @interface BulkModifyTransactionRequest
 */
export interface BulkModifyTransactionRequest {
    /**
     * 
     * @type {BulkModifyTransactionRequestInfo}
     * @memberof BulkModifyTransactionRequest
     */
    'bulkModifyTransactionRequestInfo'?: BulkModifyTransactionRequestInfo;
}
/**
 * 数値情報を一括で修正するAPIのリクエスト情報
 * @export
 * @interface BulkModifyTransactionRequestInfo
 */
export interface BulkModifyTransactionRequestInfo {
    /**
     * 集計ID
     * @type {string}
     * @memberof BulkModifyTransactionRequestInfo
     */
    'aggregateBusinessId': string;
    /**
     * 
     * @type {Array<TransactionInfo>}
     * @memberof BulkModifyTransactionRequestInfo
     */
    'data': Array<TransactionInfo>;
}
/**
 * 取引情報
 * @export
 * @interface Business
 */
export interface Business {
    /**
     * 取引ID
     * @type {string}
     * @memberof Business
     */
    'businessId'?: string;
    /**
     * 売上先CD
     * @type {string}
     * @memberof Business
     */
    'customerNumber'?: string;
    /**
     * 売上先名
     * @type {string}
     * @memberof Business
     */
    'customerName'?: string;
    /**
     * 送り先CD
     * @type {string}
     * @memberof Business
     */
    'salesDestinationNumber'?: string;
    /**
     * 送り先名
     * @type {string}
     * @memberof Business
     */
    'salesDestinationName'?: string;
    /**
     * 受領用内示名
     * @type {string}
     * @memberof Business
     */
    'forecastForReceiptName'?: string;
    /**
     * 販売実績
     * @type {Array<SalesResult>}
     * @memberof Business
     */
    'salesResults'?: Array<SalesResult>;
    /**
     * 客先内示情報
     * @type {Array<CustomerAnnounce>}
     * @memberof Business
     */
    'customerAnnounces'?: Array<CustomerAnnounce>;
    /**
     * 関連取引の更新日時情報
     * @type {number}
     * @memberof Business
     */
    'updateAt'?: number;
    /**
     * 関連取引の作成日時情報
     * @type {number}
     * @memberof Business
     */
    'createAt'?: number;
    /**
     * ユーザーデータの配列
     * @type {Array<UserData>}
     * @memberof Business
     */
    'baseBusinessResponsibleUsers'?: Array<UserData>;
    /**
     * メモ
     * @type {string}
     * @memberof Business
     */
    'baseBusinessNote'?: string;
    /**
     * エンドユーザー
     * @type {string}
     * @memberof Business
     */
    'endUser'?: string;
}
/**
 * 客先内示情報
 * @export
 * @interface CustomerAnnounce
 */
export interface CustomerAnnounce {
    /**
     * 集計ID
     * @type {string}
     * @memberof CustomerAnnounce
     */
    'aggregateBusinessId'?: string;
    /**
     * 客先内示ID
     * @type {string}
     * @memberof CustomerAnnounce
     */
    'customerAnnounceId'?: string;
    /**
     * 客先内示受領年
     * @type {number}
     * @memberof CustomerAnnounce
     */
    'customerForecastReceivedYear'?: number;
    /**
     * 客先内示受領月
     * @type {number}
     * @memberof CustomerAnnounce
     */
    'customerForecastReceivedMonth'?: number;
    /**
     * 客先内示対象年
     * @type {number}
     * @memberof CustomerAnnounce
     */
    'customerForecastTargetYear'?: number;
    /**
     * 客先内示対象月
     * @type {number}
     * @memberof CustomerAnnounce
     */
    'customerForecastTargetMonth'?: number;
    /**
     * 客先内示数量
     * @type {number}
     * @memberof CustomerAnnounce
     */
    'customerForecastAmountTotal'?: number;
}
/**
 * エラーレスポンス
 * @export
 * @interface ErrorResponse
 */
export interface ErrorResponse {
    /**
     * 
     * @type {number}
     * @memberof ErrorResponse
     */
    'statusCode': number;
    /**
     * 
     * @type {string}
     * @memberof ErrorResponse
     */
    'headers': string;
    /**
     * 
     * @type {ErrorResponseBody}
     * @memberof ErrorResponse
     */
    'body': ErrorResponseBody;
}
/**
 * 
 * @export
 * @interface ErrorResponseBody
 */
export interface ErrorResponseBody {
    /**
     * 
     * @type {number}
     * @memberof ErrorResponseBody
     */
    'statusCode': number;
    /**
     * 
     * @type {ErrorResponseCode}
     * @memberof ErrorResponseBody
     */
    'code': ErrorResponseCode;
    /**
     * 
     * @type {string}
     * @memberof ErrorResponseBody
     */
    'message': string;
}


/**
 * エラー時のレスポンスコード backendのcommon_layer/return_code.py参照
 * @export
 * @enum {string}
 */

export const ErrorResponseCode = {
    BadRequest: 'BAD_REQUEST',
    NotRegisteredBusiness: 'NOT_REGISTERED_BUSINESS',
    FkConstraintFailed: 'FK_CONSTRAINT_FAILED',
    Unauthorized: 'UNAUTHORIZED',
    Forbidden: 'FORBIDDEN',
    NotFound: 'NOT_FOUND',
    ResourceConflict: 'RESOURCE_CONFLICT',
    UpdateTimingConflict: 'UPDATE_TIMING_CONFLICT',
    InternalServerError: 'INTERNAL_SERVER_ERROR'
} as const;

export type ErrorResponseCode = typeof ErrorResponseCode[keyof typeof ErrorResponseCode];


/**
 * 在庫情報のエクスポート成功
 * @export
 * @interface ExportInventoryBusinessSuccessResponse
 */
export interface ExportInventoryBusinessSuccessResponse {
    /**
     * 
     * @type {number}
     * @memberof ExportInventoryBusinessSuccessResponse
     */
    'statusCode': number;
    /**
     * 
     * @type {number}
     * @memberof ExportInventoryBusinessSuccessResponse
     */
    'code': number;
    /**
     * 
     * @type {string}
     * @memberof ExportInventoryBusinessSuccessResponse
     */
    'message': string;
    /**
     * 
     * @type {ExportInventoryBusinessSuccessResponseResultData}
     * @memberof ExportInventoryBusinessSuccessResponse
     */
    'result': ExportInventoryBusinessSuccessResponseResultData;
}
/**
 * 在庫情報のエクスポート成功のレスポンスデータ
 * @export
 * @interface ExportInventoryBusinessSuccessResponseResultData
 */
export interface ExportInventoryBusinessSuccessResponseResultData {
    /**
     * S3からのダウンロード用署名付きURL
     * @type {string}
     * @memberof ExportInventoryBusinessSuccessResponseResultData
     */
    'download_url': string;
    /**
     * ダウンロード用ファイル名
     * @type {string}
     * @memberof ExportInventoryBusinessSuccessResponseResultData
     */
    'file_name': string;
    /**
     * URLの有効期限（ISO8601形式）
     * @type {string}
     * @memberof ExportInventoryBusinessSuccessResponseResultData
     */
    'expires_at': string;
}
/**
 * Excelエクスポートのリクエスト情報
 * @export
 * @interface ExportInventoryExcelRequest
 */
export interface ExportInventoryExcelRequest {
    /**
     * 出力対象のマスタ項目キーの配列
     * @type {Array<string>}
     * @memberof ExportInventoryExcelRequest
     */
    'masterItems': Array<string>;
    /**
     * 出力対象のデータ項目キーの配列
     * @type {Array<string>}
     * @memberof ExportInventoryExcelRequest
     */
    'outputDataItems': Array<string>;
    /**
     * 
     * @type {YearMonth}
     * @memberof ExportInventoryExcelRequest
     */
    'startYearMonth': YearMonth;
    /**
     * 
     * @type {YearMonth}
     * @memberof ExportInventoryExcelRequest
     */
    'endYearMonth': YearMonth;
    /**
     * 
     * @type {ExportOutputFormat}
     * @memberof ExportInventoryExcelRequest
     */
    'outputFormat': ExportOutputFormat;
    /**
     * 
     * @type {SortType}
     * @memberof ExportInventoryExcelRequest
     */
    'sortType'?: SortType;
    /**
     * ソート対象のカラム名
     * @type {string}
     * @memberof ExportInventoryExcelRequest
     */
    'sortTarget'?: string;
    /**
     * 
     * @type {UseFilterItem}
     * @memberof ExportInventoryExcelRequest
     */
    'filterItem'?: UseFilterItem;
    /**
     * 
     * @type {ObjectFilterInfo}
     * @memberof ExportInventoryExcelRequest
     */
    'filterItemObject'?: ObjectFilterInfo;
    /**
     * 単一フィールド項目の挿入位置（キー: 項目キー、値: 月別ヘッダー内のインデックス）
     * @type {{ [key: string]: number; }}
     * @memberof ExportInventoryExcelRequest
     */
    'singleFieldPositions'?: { [key: string]: number; };
    /**
     * 出力言語（ja: 日本語、en: 英語）
     * @type {string}
     * @memberof ExportInventoryExcelRequest
     */
    'language'?: ExportInventoryExcelRequestLanguageEnum;
}

export const ExportInventoryExcelRequestLanguageEnum = {
    Ja: 'ja',
    En: 'en'
} as const;

export type ExportInventoryExcelRequestLanguageEnum = typeof ExportInventoryExcelRequestLanguageEnum[keyof typeof ExportInventoryExcelRequestLanguageEnum];

/**
 * 出力形式
 * @export
 * @enum {string}
 */

export const ExportOutputFormat = {
    ByMonth: 'byMonth',
    ByDataType: 'byDataType'
} as const;

export type ExportOutputFormat = typeof ExportOutputFormat[keyof typeof ExportOutputFormat];


/**
 * 
 * @export
 * @interface GetInventoryAnalyticsByDimensionAggregateBusinessSuccessInner
 */
export interface GetInventoryAnalyticsByDimensionAggregateBusinessSuccessInner {
    /**
     * 
     * @type {number}
     * @memberof GetInventoryAnalyticsByDimensionAggregateBusinessSuccessInner
     */
    'statusCode': number;
    /**
     * 
     * @type {number}
     * @memberof GetInventoryAnalyticsByDimensionAggregateBusinessSuccessInner
     */
    'code': number;
    /**
     * 
     * @type {string}
     * @memberof GetInventoryAnalyticsByDimensionAggregateBusinessSuccessInner
     */
    'message': string;
    /**
     * 
     * @type {InventoryAnalyticsByDimensionAggregateBusinessInfo}
     * @memberof GetInventoryAnalyticsByDimensionAggregateBusinessSuccessInner
     */
    'result': InventoryAnalyticsByDimensionAggregateBusinessInfo;
}
/**
 * 
 * @export
 * @interface GetInventoryAnalyticsByDimensionBaseBusinessSuccessInner
 */
export interface GetInventoryAnalyticsByDimensionBaseBusinessSuccessInner {
    /**
     * 
     * @type {number}
     * @memberof GetInventoryAnalyticsByDimensionBaseBusinessSuccessInner
     */
    'statusCode': number;
    /**
     * 
     * @type {number}
     * @memberof GetInventoryAnalyticsByDimensionBaseBusinessSuccessInner
     */
    'code': number;
    /**
     * 
     * @type {string}
     * @memberof GetInventoryAnalyticsByDimensionBaseBusinessSuccessInner
     */
    'message': string;
    /**
     * 
     * @type {InventoryAnalyticsByDimensionBaseBusinessInfo}
     * @memberof GetInventoryAnalyticsByDimensionBaseBusinessSuccessInner
     */
    'result': InventoryAnalyticsByDimensionBaseBusinessInfo;
}
/**
 * 
 * @export
 * @interface GetInventoryAnalyticsDetailAggregateBusinessSuccessInner
 */
export interface GetInventoryAnalyticsDetailAggregateBusinessSuccessInner {
    /**
     * 
     * @type {number}
     * @memberof GetInventoryAnalyticsDetailAggregateBusinessSuccessInner
     */
    'statusCode': number;
    /**
     * 
     * @type {number}
     * @memberof GetInventoryAnalyticsDetailAggregateBusinessSuccessInner
     */
    'code': number;
    /**
     * 
     * @type {string}
     * @memberof GetInventoryAnalyticsDetailAggregateBusinessSuccessInner
     */
    'message': string;
    /**
     * 
     * @type {InventoryAnalyticsDetailAggreageBusinessInfo}
     * @memberof GetInventoryAnalyticsDetailAggregateBusinessSuccessInner
     */
    'result': InventoryAnalyticsDetailAggreageBusinessInfo;
}
/**
 * 
 * @export
 * @interface GetInventoryAnalyticsDetailAggregateBusinessWithAlertSuccessInner
 */
export interface GetInventoryAnalyticsDetailAggregateBusinessWithAlertSuccessInner {
    /**
     * 
     * @type {number}
     * @memberof GetInventoryAnalyticsDetailAggregateBusinessWithAlertSuccessInner
     */
    'statusCode': number;
    /**
     * 
     * @type {number}
     * @memberof GetInventoryAnalyticsDetailAggregateBusinessWithAlertSuccessInner
     */
    'code': number;
    /**
     * 
     * @type {string}
     * @memberof GetInventoryAnalyticsDetailAggregateBusinessWithAlertSuccessInner
     */
    'message': string;
    /**
     * 
     * @type {InventoryAnalyticsDetailAggreageBusinessWithAlertInfo}
     * @memberof GetInventoryAnalyticsDetailAggregateBusinessWithAlertSuccessInner
     */
    'result': InventoryAnalyticsDetailAggreageBusinessWithAlertInfo;
}
/**
 * 
 * @export
 * @interface GetInventoryAnalyticsDetailBaseBusinessSuccessInner
 */
export interface GetInventoryAnalyticsDetailBaseBusinessSuccessInner {
    /**
     * 
     * @type {number}
     * @memberof GetInventoryAnalyticsDetailBaseBusinessSuccessInner
     */
    'statusCode': number;
    /**
     * 
     * @type {number}
     * @memberof GetInventoryAnalyticsDetailBaseBusinessSuccessInner
     */
    'code': number;
    /**
     * 
     * @type {string}
     * @memberof GetInventoryAnalyticsDetailBaseBusinessSuccessInner
     */
    'message': string;
    /**
     * 
     * @type {InventoryAnalyticsDetailBaseBusinessInfo}
     * @memberof GetInventoryAnalyticsDetailBaseBusinessSuccessInner
     */
    'result': InventoryAnalyticsDetailBaseBusinessInfo;
}
/**
 * 
 * @export
 * @interface GetInventoryAnalyticsOverviewSuccessInner
 */
export interface GetInventoryAnalyticsOverviewSuccessInner {
    /**
     * 
     * @type {number}
     * @memberof GetInventoryAnalyticsOverviewSuccessInner
     */
    'statusCode': number;
    /**
     * 
     * @type {number}
     * @memberof GetInventoryAnalyticsOverviewSuccessInner
     */
    'code': number;
    /**
     * 
     * @type {string}
     * @memberof GetInventoryAnalyticsOverviewSuccessInner
     */
    'message': string;
    /**
     * 
     * @type {InventoryAnalyticsOverviewInfo}
     * @memberof GetInventoryAnalyticsOverviewSuccessInner
     */
    'result': InventoryAnalyticsOverviewInfo;
}
/**
 * 展開機能APIのレスポンスで返ってくるデータの型
 * @export
 * @interface GetInventoryBusinessSuccessResponse
 */
export interface GetInventoryBusinessSuccessResponse {
    /**
     * 
     * @type {number}
     * @memberof GetInventoryBusinessSuccessResponse
     */
    'statusCode': number;
    /**
     * 
     * @type {number}
     * @memberof GetInventoryBusinessSuccessResponse
     */
    'code': number;
    /**
     * 
     * @type {string}
     * @memberof GetInventoryBusinessSuccessResponse
     */
    'message': string;
    /**
     * 
     * @type {GetInventoryBusinessSuccessResponseInfo}
     * @memberof GetInventoryBusinessSuccessResponse
     */
    'result': GetInventoryBusinessSuccessResponseInfo;
}
/**
 * 
 * @export
 * @interface GetInventoryBusinessSuccessResponseInfo
 */
export interface GetInventoryBusinessSuccessResponseInfo {
    /**
     * 
     * @type {Array<Business>}
     * @memberof GetInventoryBusinessSuccessResponseInfo
     */
    'data'?: Array<Business>;
    /**
     * 
     * @type {PagingOptions}
     * @memberof GetInventoryBusinessSuccessResponseInfo
     */
    'pagingOptions'?: PagingOptions;
}
/**
 * 在庫管理情報の取得APIのレスポンスで返ってくるデータの型
 * @export
 * @interface GetInventorySuccessResponse
 */
export interface GetInventorySuccessResponse {
    /**
     * 
     * @type {number}
     * @memberof GetInventorySuccessResponse
     */
    'statusCode': number;
    /**
     * 
     * @type {number}
     * @memberof GetInventorySuccessResponse
     */
    'code': number;
    /**
     * 
     * @type {string}
     * @memberof GetInventorySuccessResponse
     */
    'message': string;
    /**
     * 
     * @type {GetInventorySuccessResponseInfo}
     * @memberof GetInventorySuccessResponse
     */
    'result': GetInventorySuccessResponseInfo;
}
/**
 * 
 * @export
 * @interface GetInventorySuccessResponseInfo
 */
export interface GetInventorySuccessResponseInfo {
    /**
     * 
     * @type {Array<AggregateBusiness>}
     * @memberof GetInventorySuccessResponseInfo
     */
    'data'?: Array<AggregateBusiness>;
    /**
     * 
     * @type {SummaryData}
     * @memberof GetInventorySuccessResponseInfo
     */
    'summaryData'?: SummaryData;
    /**
     * 
     * @type {PagingOptions}
     * @memberof GetInventorySuccessResponseInfo
     */
    'pagingOptions'?: PagingOptions;
}
/**
 * 関連取引の販売実績・内示データ取得APIのレスポンスで返ってくるデータの型
 * @export
 * @interface GetRelatedTransactionsDetailSuccessResponse
 */
export interface GetRelatedTransactionsDetailSuccessResponse {
    /**
     * 
     * @type {number}
     * @memberof GetRelatedTransactionsDetailSuccessResponse
     */
    'statusCode': number;
    /**
     * 
     * @type {number}
     * @memberof GetRelatedTransactionsDetailSuccessResponse
     */
    'code': number;
    /**
     * 
     * @type {string}
     * @memberof GetRelatedTransactionsDetailSuccessResponse
     */
    'message': string;
    /**
     * 
     * @type {GetRelatedTransactionsDetailSuccessResponseInfo}
     * @memberof GetRelatedTransactionsDetailSuccessResponse
     */
    'result': GetRelatedTransactionsDetailSuccessResponseInfo;
}
/**
 * 関連取引の販売実績・内示データ
 * @export
 * @interface GetRelatedTransactionsDetailSuccessResponseInfo
 */
export interface GetRelatedTransactionsDetailSuccessResponseInfo {
    /**
     * 関連取引のリスト
     * @type {Array<RelatedTransaction>}
     * @memberof GetRelatedTransactionsDetailSuccessResponseInfo
     */
    'transactions': Array<RelatedTransaction>;
}
/**
 * 在庫情報
 * @export
 * @interface Inventory
 */
export interface Inventory {
    /**
     * 集計ID
     * @type {string}
     * @memberof Inventory
     */
    'aggregateBusinessId'?: string;
    /**
     * 在庫ID
     * @type {string}
     * @memberof Inventory
     */
    'inventoryId'?: string;
    /**
     * 在庫年
     * @type {number}
     * @memberof Inventory
     */
    'targetYear'?: number;
    /**
     * 在庫月
     * @type {number}
     * @memberof Inventory
     */
    'targetMonth'?: number;
    /**
     * 在庫数量
     * @type {number}
     * @memberof Inventory
     */
    'inventoryAmount'?: number;
}
/**
 * 
 * @export
 * @interface InventoryAnalyticsByDimensionAggregateBusiness
 */
export interface InventoryAnalyticsByDimensionAggregateBusiness {
    /**
     * 
     * @type {InventoryAnalyticsByDimensionAggregateBusinessDimensionValues}
     * @memberof InventoryAnalyticsByDimensionAggregateBusiness
     */
    'dimensionValues': InventoryAnalyticsByDimensionAggregateBusinessDimensionValues;
    /**
     * 
     * @type {Array<InventoryAnalyticsByDimensionAggregateBusinessKpiInner>}
     * @memberof InventoryAnalyticsByDimensionAggregateBusiness
     */
    'kpi'?: Array<InventoryAnalyticsByDimensionAggregateBusinessKpiInner>;
    /**
     * 
     * @type {Array<InventoryAnalyticsByDimensionAggregateBusinessSummaryDataInner>}
     * @memberof InventoryAnalyticsByDimensionAggregateBusiness
     */
    'summaryData'?: Array<InventoryAnalyticsByDimensionAggregateBusinessSummaryDataInner>;
    /**
     * 
     * @type {Array<InventoryAnalyticsByDimensionAggregateBusinessBusinessDataInner>}
     * @memberof InventoryAnalyticsByDimensionAggregateBusiness
     */
    'businessData'?: Array<InventoryAnalyticsByDimensionAggregateBusinessBusinessDataInner>;
}
/**
 * 在庫分析詳細情報(集計)
 * @export
 * @interface InventoryAnalyticsByDimensionAggregateBusinessBusinessDataInner
 */
export interface InventoryAnalyticsByDimensionAggregateBusinessBusinessDataInner {
    /**
     * 組織ID
     * @type {string}
     * @memberof InventoryAnalyticsByDimensionAggregateBusinessBusinessDataInner
     */
    'organizationId': string;
    /**
     * 集計ID
     * @type {string}
     * @memberof InventoryAnalyticsByDimensionAggregateBusinessBusinessDataInner
     */
    'aggregateBusinessId': string;
    /**
     * 置場コード
     * @type {string}
     * @memberof InventoryAnalyticsByDimensionAggregateBusinessBusinessDataInner
     */
    'warehouseNumber': string;
    /**
     * 置場名
     * @type {string}
     * @memberof InventoryAnalyticsByDimensionAggregateBusinessBusinessDataInner
     */
    'warehouse': string;
    /**
     * 仕入先コード
     * @type {string}
     * @memberof InventoryAnalyticsByDimensionAggregateBusinessBusinessDataInner
     */
    'supplierNumber': string;
    /**
     * 仕入先名
     * @type {string}
     * @memberof InventoryAnalyticsByDimensionAggregateBusinessBusinessDataInner
     */
    'supplierName': string;
    /**
     * 商品コード
     * @type {string}
     * @memberof InventoryAnalyticsByDimensionAggregateBusinessBusinessDataInner
     */
    'businessNumber': string;
    /**
     * 商品名
     * @type {string}
     * @memberof InventoryAnalyticsByDimensionAggregateBusinessBusinessDataInner
     */
    'businessName': string;
    /**
     * ユーザーデータの配列
     * @type {Array<UserData>}
     * @memberof InventoryAnalyticsByDimensionAggregateBusinessBusinessDataInner
     */
    'aggregateBusinessReponsibleUsers': Array<UserData>;
    /**
     * 製造社
     * @type {string}
     * @memberof InventoryAnalyticsByDimensionAggregateBusinessBusinessDataInner
     */
    'manufacturer'?: string;
    /**
     * 末在庫
     * @type {string}
     * @memberof InventoryAnalyticsByDimensionAggregateBusinessBusinessDataInner
     */
    'endInventoryAmount'?: string;
    /**
     * 客先内示
     * @type {string}
     * @memberof InventoryAnalyticsByDimensionAggregateBusinessBusinessDataInner
     */
    'customerForecastAmount'?: string;
    /**
     * 販売実績
     * @type {string}
     * @memberof InventoryAnalyticsByDimensionAggregateBusinessBusinessDataInner
     */
    'salesResultAmount'?: string;
    /**
     * 在庫回転率
     * @type {string}
     * @memberof InventoryAnalyticsByDimensionAggregateBusinessBusinessDataInner
     */
    'turnover'?: string;
    /**
     * 入荷
     * @type {string}
     * @memberof InventoryAnalyticsByDimensionAggregateBusinessBusinessDataInner
     */
    'arrivalAmount'?: string;
    /**
     * 発注数量
     * @type {string}
     * @memberof InventoryAnalyticsByDimensionAggregateBusinessBusinessDataInner
     */
    'orderAmount'?: string;
    /**
     * 仕入先内示
     * @type {string}
     * @memberof InventoryAnalyticsByDimensionAggregateBusinessBusinessDataInner
     */
    'supplierForecastAmount'?: string;
}
/**
 * 
 * @export
 * @interface InventoryAnalyticsByDimensionAggregateBusinessDimensionValues
 */
export interface InventoryAnalyticsByDimensionAggregateBusinessDimensionValues {
    /**
     * 
     * @type {string}
     * @memberof InventoryAnalyticsByDimensionAggregateBusinessDimensionValues
     */
    'code'?: string;
    /**
     * 
     * @type {string}
     * @memberof InventoryAnalyticsByDimensionAggregateBusinessDimensionValues
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof InventoryAnalyticsByDimensionAggregateBusinessDimensionValues
     */
    'value'?: string;
    /**
     * 
     * @type {string}
     * @memberof InventoryAnalyticsByDimensionAggregateBusinessDimensionValues
     */
    'unit'?: string;
}
/**
 * 
 * @export
 * @interface InventoryAnalyticsByDimensionAggregateBusinessInfo
 */
export interface InventoryAnalyticsByDimensionAggregateBusinessInfo {
    /**
     * 
     * @type {Array<InventoryAnalyticsByDimensionAggregateBusiness>}
     * @memberof InventoryAnalyticsByDimensionAggregateBusinessInfo
     */
    'data': Array<InventoryAnalyticsByDimensionAggregateBusiness>;
}
/**
 * 
 * @export
 * @interface InventoryAnalyticsByDimensionAggregateBusinessKpiInner
 */
export interface InventoryAnalyticsByDimensionAggregateBusinessKpiInner {
    /**
     * 
     * @type {string}
     * @memberof InventoryAnalyticsByDimensionAggregateBusinessKpiInner
     */
    'kpiValue'?: string;
    /**
     * 
     * @type {number}
     * @memberof InventoryAnalyticsByDimensionAggregateBusinessKpiInner
     */
    'validFrom'?: number;
    /**
     * 
     * @type {number}
     * @memberof InventoryAnalyticsByDimensionAggregateBusinessKpiInner
     */
    'validTo'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof InventoryAnalyticsByDimensionAggregateBusinessKpiInner
     */
    'isCurrent'?: boolean;
}
/**
 * 
 * @export
 * @interface InventoryAnalyticsByDimensionAggregateBusinessSummaryDataInner
 */
export interface InventoryAnalyticsByDimensionAggregateBusinessSummaryDataInner {
    /**
     * 
     * @type {number}
     * @memberof InventoryAnalyticsByDimensionAggregateBusinessSummaryDataInner
     */
    'year': number;
    /**
     * 
     * @type {number}
     * @memberof InventoryAnalyticsByDimensionAggregateBusinessSummaryDataInner
     */
    'month': number;
    /**
     * 
     * @type {string}
     * @memberof InventoryAnalyticsByDimensionAggregateBusinessSummaryDataInner
     */
    'endInventory'?: string;
    /**
     * 
     * @type {string}
     * @memberof InventoryAnalyticsByDimensionAggregateBusinessSummaryDataInner
     */
    'salesResult'?: string;
    /**
     * 
     * @type {string}
     * @memberof InventoryAnalyticsByDimensionAggregateBusinessSummaryDataInner
     */
    'customerForecast'?: string;
    /**
     * 
     * @type {string}
     * @memberof InventoryAnalyticsByDimensionAggregateBusinessSummaryDataInner
     */
    'arrival'?: string;
    /**
     * 
     * @type {string}
     * @memberof InventoryAnalyticsByDimensionAggregateBusinessSummaryDataInner
     */
    'turnover'?: string;
    /**
     * 
     * @type {string}
     * @memberof InventoryAnalyticsByDimensionAggregateBusinessSummaryDataInner
     */
    'averageForecastAccuracy'?: string;
    /**
     * 
     * @type {string}
     * @memberof InventoryAnalyticsByDimensionAggregateBusinessSummaryDataInner
     */
    'turnoverWithForecastAccuracy'?: string;
    /**
     * 
     * @type {string}
     * @memberof InventoryAnalyticsByDimensionAggregateBusinessSummaryDataInner
     */
    'forecastAccuracy'?: string;
    /**
     * 
     * @type {string}
     * @memberof InventoryAnalyticsByDimensionAggregateBusinessSummaryDataInner
     */
    'orderAmount'?: string;
    /**
     * 
     * @type {string}
     * @memberof InventoryAnalyticsByDimensionAggregateBusinessSummaryDataInner
     */
    'supplierForecast'?: string;
}
/**
 * 
 * @export
 * @interface InventoryAnalyticsByDimensionBaseBusiness
 */
export interface InventoryAnalyticsByDimensionBaseBusiness {
    /**
     * 
     * @type {InventoryAnalyticsByDimensionAggregateBusinessDimensionValues}
     * @memberof InventoryAnalyticsByDimensionBaseBusiness
     */
    'dimensionValues': InventoryAnalyticsByDimensionAggregateBusinessDimensionValues;
    /**
     * 
     * @type {Array<InventoryAnalyticsByDimensionAggregateBusinessKpiInner>}
     * @memberof InventoryAnalyticsByDimensionBaseBusiness
     */
    'kpi'?: Array<InventoryAnalyticsByDimensionAggregateBusinessKpiInner>;
    /**
     * 
     * @type {Array<InventoryAnalyticsByDimensionBaseBusinessSummaryDataInner>}
     * @memberof InventoryAnalyticsByDimensionBaseBusiness
     */
    'summaryData'?: Array<InventoryAnalyticsByDimensionBaseBusinessSummaryDataInner>;
    /**
     * 
     * @type {Array<InventoryAnalyticsByDimensionBaseBusinessBusinessDataInner>}
     * @memberof InventoryAnalyticsByDimensionBaseBusiness
     */
    'businessData'?: Array<InventoryAnalyticsByDimensionBaseBusinessBusinessDataInner>;
}
/**
 * 在庫分析詳細情報(取引)
 * @export
 * @interface InventoryAnalyticsByDimensionBaseBusinessBusinessDataInner
 */
export interface InventoryAnalyticsByDimensionBaseBusinessBusinessDataInner {
    /**
     * 組織ID
     * @type {string}
     * @memberof InventoryAnalyticsByDimensionBaseBusinessBusinessDataInner
     */
    'organizationId': string;
    /**
     * 取引ID
     * @type {string}
     * @memberof InventoryAnalyticsByDimensionBaseBusinessBusinessDataInner
     */
    'baseBusinessId': string;
    /**
     * 置場コード
     * @type {string}
     * @memberof InventoryAnalyticsByDimensionBaseBusinessBusinessDataInner
     */
    'warehouseNumber': string;
    /**
     * 置場名
     * @type {string}
     * @memberof InventoryAnalyticsByDimensionBaseBusinessBusinessDataInner
     */
    'warehouse': string;
    /**
     * 仕入先コード
     * @type {string}
     * @memberof InventoryAnalyticsByDimensionBaseBusinessBusinessDataInner
     */
    'supplierNumber': string;
    /**
     * 仕入先名
     * @type {string}
     * @memberof InventoryAnalyticsByDimensionBaseBusinessBusinessDataInner
     */
    'supplierName': string;
    /**
     * 商品コード
     * @type {string}
     * @memberof InventoryAnalyticsByDimensionBaseBusinessBusinessDataInner
     */
    'businessNumber': string;
    /**
     * 商品名
     * @type {string}
     * @memberof InventoryAnalyticsByDimensionBaseBusinessBusinessDataInner
     */
    'businessName': string;
    /**
     * 容量
     * @type {string}
     * @memberof InventoryAnalyticsByDimensionBaseBusinessBusinessDataInner
     */
    'package': string;
    /**
     * 売上先コード
     * @type {string}
     * @memberof InventoryAnalyticsByDimensionBaseBusinessBusinessDataInner
     */
    'customerNumber': string;
    /**
     * 売上先名
     * @type {string}
     * @memberof InventoryAnalyticsByDimensionBaseBusinessBusinessDataInner
     */
    'customerName': string;
    /**
     * 送り先コード
     * @type {string}
     * @memberof InventoryAnalyticsByDimensionBaseBusinessBusinessDataInner
     */
    'salesDestinationNumber': string;
    /**
     * 送り先名
     * @type {string}
     * @memberof InventoryAnalyticsByDimensionBaseBusinessBusinessDataInner
     */
    'salesDestinationName': string;
    /**
     * ユーザーデータの配列
     * @type {Array<UserData>}
     * @memberof InventoryAnalyticsByDimensionBaseBusinessBusinessDataInner
     */
    'baseBusinessResponsibleUsers'?: Array<UserData>;
    /**
     * エンドユーザー
     * @type {string}
     * @memberof InventoryAnalyticsByDimensionBaseBusinessBusinessDataInner
     */
    'endUser'?: string;
    /**
     * 客先内示
     * @type {string}
     * @memberof InventoryAnalyticsByDimensionBaseBusinessBusinessDataInner
     */
    'customerForecastAmount'?: string;
    /**
     * 販売実績
     * @type {string}
     * @memberof InventoryAnalyticsByDimensionBaseBusinessBusinessDataInner
     */
    'salesResultAmount'?: string;
    /**
     * 
     * @type {string}
     * @memberof InventoryAnalyticsByDimensionBaseBusinessBusinessDataInner
     */
    'forecastAccuracy'?: string;
}
/**
 * 
 * @export
 * @interface InventoryAnalyticsByDimensionBaseBusinessInfo
 */
export interface InventoryAnalyticsByDimensionBaseBusinessInfo {
    /**
     * 
     * @type {Array<InventoryAnalyticsByDimensionBaseBusiness>}
     * @memberof InventoryAnalyticsByDimensionBaseBusinessInfo
     */
    'data': Array<InventoryAnalyticsByDimensionBaseBusiness>;
}
/**
 * 
 * @export
 * @interface InventoryAnalyticsByDimensionBaseBusinessSummaryDataInner
 */
export interface InventoryAnalyticsByDimensionBaseBusinessSummaryDataInner {
    /**
     * 
     * @type {number}
     * @memberof InventoryAnalyticsByDimensionBaseBusinessSummaryDataInner
     */
    'year': number;
    /**
     * 
     * @type {number}
     * @memberof InventoryAnalyticsByDimensionBaseBusinessSummaryDataInner
     */
    'month': number;
    /**
     * 
     * @type {string}
     * @memberof InventoryAnalyticsByDimensionBaseBusinessSummaryDataInner
     */
    'salesResult'?: string;
    /**
     * 
     * @type {string}
     * @memberof InventoryAnalyticsByDimensionBaseBusinessSummaryDataInner
     */
    'customerForecast'?: string;
    /**
     * 
     * @type {string}
     * @memberof InventoryAnalyticsByDimensionBaseBusinessSummaryDataInner
     */
    'forecastAccuracy'?: string;
}
/**
 * 在庫分析詳細情報(集計)
 * @export
 * @interface InventoryAnalyticsDetailAggreageBusiness
 */
export interface InventoryAnalyticsDetailAggreageBusiness {
    /**
     * 組織ID
     * @type {string}
     * @memberof InventoryAnalyticsDetailAggreageBusiness
     */
    'organizationId': string;
    /**
     * 集計ID
     * @type {string}
     * @memberof InventoryAnalyticsDetailAggreageBusiness
     */
    'aggregateBusinessId': string;
    /**
     * 置場コード
     * @type {string}
     * @memberof InventoryAnalyticsDetailAggreageBusiness
     */
    'warehouseNumber': string;
    /**
     * 置場名
     * @type {string}
     * @memberof InventoryAnalyticsDetailAggreageBusiness
     */
    'warehouse': string;
    /**
     * 仕入先コード
     * @type {string}
     * @memberof InventoryAnalyticsDetailAggreageBusiness
     */
    'supplierNumber': string;
    /**
     * 仕入先名
     * @type {string}
     * @memberof InventoryAnalyticsDetailAggreageBusiness
     */
    'supplierName': string;
    /**
     * 商品コード
     * @type {string}
     * @memberof InventoryAnalyticsDetailAggreageBusiness
     */
    'businessNumber': string;
    /**
     * 商品名
     * @type {string}
     * @memberof InventoryAnalyticsDetailAggreageBusiness
     */
    'businessName': string;
    /**
     * ユーザーデータの配列
     * @type {Array<UserData>}
     * @memberof InventoryAnalyticsDetailAggreageBusiness
     */
    'aggregateBusinessReponsibleUsers': Array<UserData>;
    /**
     * 最新の現在庫
     * @type {string}
     * @memberof InventoryAnalyticsDetailAggreageBusiness
     */
    'latestInventoryAmount'?: string;
    /**
     * 先月の末在庫
     * @type {string}
     * @memberof InventoryAnalyticsDetailAggreageBusiness
     */
    'lastMonthEndInventoryAmount'?: string;
    /**
     * 先月の販売実績
     * @type {string}
     * @memberof InventoryAnalyticsDetailAggreageBusiness
     */
    'lastMonthSalesResultAmount'?: string;
    /**
     * 在庫回転率
     * @type {string}
     * @memberof InventoryAnalyticsDetailAggreageBusiness
     */
    'turnover'?: string;
}
/**
 * 
 * @export
 * @interface InventoryAnalyticsDetailAggreageBusinessInfo
 */
export interface InventoryAnalyticsDetailAggreageBusinessInfo {
    /**
     * 
     * @type {Array<InventoryAnalyticsDetailAggreageBusiness>}
     * @memberof InventoryAnalyticsDetailAggreageBusinessInfo
     */
    'data': Array<InventoryAnalyticsDetailAggreageBusiness>;
    /**
     * 
     * @type {PagingOptions}
     * @memberof InventoryAnalyticsDetailAggreageBusinessInfo
     */
    'pagingOptions': PagingOptions;
}
/**
 * 
 * @export
 * @interface InventoryAnalyticsDetailAggreageBusinessWithAlertInfo
 */
export interface InventoryAnalyticsDetailAggreageBusinessWithAlertInfo {
    /**
     * 
     * @type {Array<InventoryAnalyticsDetailAggreageBusinessWithAlertInfoBusinessDataInner>}
     * @memberof InventoryAnalyticsDetailAggreageBusinessWithAlertInfo
     */
    'businessData': Array<InventoryAnalyticsDetailAggreageBusinessWithAlertInfoBusinessDataInner>;
    /**
     * 
     * @type {InventoryAnalyticsDetailAggreageBusinessWithAlertInfoNumberData}
     * @memberof InventoryAnalyticsDetailAggreageBusinessWithAlertInfo
     */
    'numberData': InventoryAnalyticsDetailAggreageBusinessWithAlertInfoNumberData;
    /**
     * 
     * @type {PagingOptions}
     * @memberof InventoryAnalyticsDetailAggreageBusinessWithAlertInfo
     */
    'pagingOptions': PagingOptions;
}
/**
 * 
 * @export
 * @interface InventoryAnalyticsDetailAggreageBusinessWithAlertInfoBusinessDataInner
 */
export interface InventoryAnalyticsDetailAggreageBusinessWithAlertInfoBusinessDataInner {
    /**
     * 組織ID
     * @type {string}
     * @memberof InventoryAnalyticsDetailAggreageBusinessWithAlertInfoBusinessDataInner
     */
    'organizationId': string;
    /**
     * 集計ID
     * @type {string}
     * @memberof InventoryAnalyticsDetailAggreageBusinessWithAlertInfoBusinessDataInner
     */
    'aggregateBusinessId': string;
    /**
     * 置場コード
     * @type {string}
     * @memberof InventoryAnalyticsDetailAggreageBusinessWithAlertInfoBusinessDataInner
     */
    'warehouseNumber': string;
    /**
     * 置場名
     * @type {string}
     * @memberof InventoryAnalyticsDetailAggreageBusinessWithAlertInfoBusinessDataInner
     */
    'warehouse': string;
    /**
     * 仕入先コード
     * @type {string}
     * @memberof InventoryAnalyticsDetailAggreageBusinessWithAlertInfoBusinessDataInner
     */
    'supplierNumber': string;
    /**
     * 仕入先名
     * @type {string}
     * @memberof InventoryAnalyticsDetailAggreageBusinessWithAlertInfoBusinessDataInner
     */
    'supplierName': string;
    /**
     * 商品コード
     * @type {string}
     * @memberof InventoryAnalyticsDetailAggreageBusinessWithAlertInfoBusinessDataInner
     */
    'businessNumber': string;
    /**
     * 商品名
     * @type {string}
     * @memberof InventoryAnalyticsDetailAggreageBusinessWithAlertInfoBusinessDataInner
     */
    'businessName': string;
    /**
     * ユーザーデータの配列
     * @type {Array<UserData>}
     * @memberof InventoryAnalyticsDetailAggreageBusinessWithAlertInfoBusinessDataInner
     */
    'aggregateBusinessReponsibleUsers': Array<UserData>;
    /**
     * 最新の現在庫
     * @type {string}
     * @memberof InventoryAnalyticsDetailAggreageBusinessWithAlertInfoBusinessDataInner
     */
    'latestInventoryAmount'?: string;
    /**
     * 先月の末在庫
     * @type {string}
     * @memberof InventoryAnalyticsDetailAggreageBusinessWithAlertInfoBusinessDataInner
     */
    'lastMonthEndInventoryAmount'?: string;
    /**
     * 先月の販売実績
     * @type {string}
     * @memberof InventoryAnalyticsDetailAggreageBusinessWithAlertInfoBusinessDataInner
     */
    'lastMonthSalesResultAmount'?: string;
    /**
     * 在庫回転率
     * @type {string}
     * @memberof InventoryAnalyticsDetailAggreageBusinessWithAlertInfoBusinessDataInner
     */
    'turnover'?: string;
    /**
     * 
     * @type {string}
     * @memberof InventoryAnalyticsDetailAggreageBusinessWithAlertInfoBusinessDataInner
     */
    'alertType'?: string;
}
/**
 * 
 * @export
 * @interface InventoryAnalyticsDetailAggreageBusinessWithAlertInfoNumberData
 */
export interface InventoryAnalyticsDetailAggreageBusinessWithAlertInfoNumberData {
    /**
     * 過剰
     * @type {number}
     * @memberof InventoryAnalyticsDetailAggreageBusinessWithAlertInfoNumberData
     */
    'excess'?: number;
    /**
     * 不足
     * @type {number}
     * @memberof InventoryAnalyticsDetailAggreageBusinessWithAlertInfoNumberData
     */
    'shortage'?: number;
    /**
     * 未照合の数
     * @type {number}
     * @memberof InventoryAnalyticsDetailAggreageBusinessWithAlertInfoNumberData
     */
    'unmatched'?: number;
    /**
     * 発注番号なし
     * @type {number}
     * @memberof InventoryAnalyticsDetailAggreageBusinessWithAlertInfoNumberData
     */
    'noOrderNumber'?: number;
    /**
     * ETA今日以前かつ納入まだ
     * @type {number}
     * @memberof InventoryAnalyticsDetailAggreageBusinessWithAlertInfoNumberData
     */
    'deadline'?: number;
}
/**
 * 在庫分析詳細情報(取引)
 * @export
 * @interface InventoryAnalyticsDetailBaseBusiness
 */
export interface InventoryAnalyticsDetailBaseBusiness {
    /**
     * 組織ID
     * @type {string}
     * @memberof InventoryAnalyticsDetailBaseBusiness
     */
    'organizationId': string;
    /**
     * 集計ID
     * @type {string}
     * @memberof InventoryAnalyticsDetailBaseBusiness
     */
    'aggregateBusinessId': string;
    /**
     * 置場コード
     * @type {string}
     * @memberof InventoryAnalyticsDetailBaseBusiness
     */
    'warehouseNumber': string;
    /**
     * 置場名
     * @type {string}
     * @memberof InventoryAnalyticsDetailBaseBusiness
     */
    'warehouse': string;
    /**
     * 仕入先コード
     * @type {string}
     * @memberof InventoryAnalyticsDetailBaseBusiness
     */
    'supplierNumber': string;
    /**
     * 仕入先名
     * @type {string}
     * @memberof InventoryAnalyticsDetailBaseBusiness
     */
    'supplierName': string;
    /**
     * 商品コード
     * @type {string}
     * @memberof InventoryAnalyticsDetailBaseBusiness
     */
    'businessNumber': string;
    /**
     * 商品名
     * @type {string}
     * @memberof InventoryAnalyticsDetailBaseBusiness
     */
    'businessName': string;
    /**
     * ユーザーデータの配列
     * @type {Array<UserData>}
     * @memberof InventoryAnalyticsDetailBaseBusiness
     */
    'aggregateBusinessReponsibleUsers': Array<UserData>;
    /**
     * 関連取引ID
     * @type {string}
     * @memberof InventoryAnalyticsDetailBaseBusiness
     */
    'baseBusinessId': string;
    /**
     * 売上先コード
     * @type {string}
     * @memberof InventoryAnalyticsDetailBaseBusiness
     */
    'customerNumber': string;
    /**
     * 売上先名
     * @type {string}
     * @memberof InventoryAnalyticsDetailBaseBusiness
     */
    'customerName': string;
    /**
     * 送り先コード
     * @type {string}
     * @memberof InventoryAnalyticsDetailBaseBusiness
     */
    'salesDestinationNumber': string;
    /**
     * 送り先名
     * @type {string}
     * @memberof InventoryAnalyticsDetailBaseBusiness
     */
    'salesDestinationName': string;
    /**
     * ユーザーデータの配列
     * @type {Array<UserData>}
     * @memberof InventoryAnalyticsDetailBaseBusiness
     */
    'baseBusinessResponsibleUsers'?: Array<UserData>;
    /**
     * 受領用内示ID
     * @type {string}
     * @memberof InventoryAnalyticsDetailBaseBusiness
     */
    'forecastForReceiptId'?: string;
    /**
     * 受領用内示名
     * @type {string}
     * @memberof InventoryAnalyticsDetailBaseBusiness
     */
    'forecastForReceiptName'?: string;
    /**
     * ユーザーデータの配列
     * @type {Array<UserData>}
     * @memberof InventoryAnalyticsDetailBaseBusiness
     */
    'forecastForReceiptResponsibleUsers'?: Array<UserData>;
    /**
     * 先月の販売実績
     * @type {string}
     * @memberof InventoryAnalyticsDetailBaseBusiness
     */
    'lastMonthSalesResultAmount'?: string;
    /**
     * 先月の内示
     * @type {string}
     * @memberof InventoryAnalyticsDetailBaseBusiness
     */
    'lastMonthcustomerForecastAmount'?: string;
    /**
     * 内示正答率
     * @type {string}
     * @memberof InventoryAnalyticsDetailBaseBusiness
     */
    'forecastAccuracy'?: string;
}
/**
 * 
 * @export
 * @interface InventoryAnalyticsDetailBaseBusinessInfo
 */
export interface InventoryAnalyticsDetailBaseBusinessInfo {
    /**
     * 
     * @type {Array<InventoryAnalyticsDetailBaseBusiness>}
     * @memberof InventoryAnalyticsDetailBaseBusinessInfo
     */
    'data': Array<InventoryAnalyticsDetailBaseBusiness>;
    /**
     * 
     * @type {PagingOptions}
     * @memberof InventoryAnalyticsDetailBaseBusinessInfo
     */
    'pagingOptions': PagingOptions;
}
/**
 * 在庫分析概要情報
 * @export
 * @interface InventoryAnalyticsOverviewInfo
 */
export interface InventoryAnalyticsOverviewInfo {
    /**
     * 現在庫の合計(最も新しい現在庫と同じ年月のもの)
     * @type {string}
     * @memberof InventoryAnalyticsOverviewInfo
     */
    'totalCurrentInventoryAmount': string;
    /**
     * 組織内全集計の在庫回転率の平均
     * @type {string}
     * @memberof InventoryAnalyticsOverviewInfo
     */
    'averageTurnover'?: string;
    /**
     * 組織内全集計の内示正答率の平均
     * @type {string}
     * @memberof InventoryAnalyticsOverviewInfo
     */
    'averageForecastAccuracy'?: string;
    /**
     * 要注意リスト内の取引・発注の数
     * @type {number}
     * @memberof InventoryAnalyticsOverviewInfo
     */
    'warningBusinessCount'?: number;
    /**
     * 危険リスト内の取引の数
     * @type {number}
     * @memberof InventoryAnalyticsOverviewInfo
     */
    'criticalBusinessCount'?: number;
}
/**
 * 
 * @export
 * @interface InventoryPostRequest
 */
export interface InventoryPostRequest {
    /**
     * 
     * @type {PostInventoryRequestInfo}
     * @memberof InventoryPostRequest
     */
    'postInventoryInfo'?: PostInventoryRequestInfo;
}
/**
 * objectで渡すフィルターの情報
 * @export
 * @interface ObjectFilterInfo
 */
export interface ObjectFilterInfo {
    /**
     * [{value: number, unit: string}]のようなデータをJSONにし、それをzlibを用いて圧縮したリードタイム情報
     * @type {string}
     * @memberof ObjectFilterInfo
     */
    'leadTimeInfoList'?: string;
    /**
     * [{value: number, unit: string}]のようなデータをJSONにし、それをzlibを用いて圧縮した標準在庫指数(min)情報
     * @type {string}
     * @memberof ObjectFilterInfo
     */
    'stdInventoryIndexMinInfoList'?: string;
    /**
     * [{value: number, unit: string}]のようなデータをJSONにし、それをzlibを用いて圧縮した標準在庫指数(max)情報
     * @type {string}
     * @memberof ObjectFilterInfo
     */
    'stdInventoryIndexMaxInfoList'?: string;
}
/**
 * 発注情報
 * @export
 * @interface Order
 */
export interface Order {
    /**
     * 集計ID
     * @type {string}
     * @memberof Order
     */
    'aggregateBusinessId'?: string;
    /**
     * 発注ID
     * @type {string}
     * @memberof Order
     */
    'orderId'?: string;
    /**
     * 発注番号
     * @type {string}
     * @memberof Order
     */
    'orderNumber'?: string;
    /**
     * 発注作成日
     * @type {number}
     * @memberof Order
     */
    'createdOrderDate'?: number;
    /**
     * 入荷予定日
     * @type {number}
     * @memberof Order
     */
    'estimatedTimeOfArrival'?: number;
    /**
     * 発注数量
     * @type {number}
     * @memberof Order
     */
    'orderAmount'?: number;
    /**
     * 発注ステータス
     * @type {string}
     * @memberof Order
     */
    'orderStatus'?: string;
    /**
     * 更新日時
     * @type {number}
     * @memberof Order
     */
    'updateAt'?: number;
    /**
     * 分納情報
     * @type {Array<PartialDelivery>}
     * @memberof Order
     */
    'partialDeliveries'?: Array<PartialDelivery>;
}
/**
 * APIから受け取るpagingOptionsの情報
 * @export
 * @interface PagingOptions
 */
export interface PagingOptions {
    /**
     * 
     * @type {number}
     * @memberof PagingOptions
     */
    'offset': number;
    /**
     * 
     * @type {number}
     * @memberof PagingOptions
     */
    'nextOffset': number;
    /**
     * 
     * @type {number}
     * @memberof PagingOptions
     */
    'pageSize': number;
    /**
     * 
     * @type {number}
     * @memberof PagingOptions
     */
    'totalResultsAvailable': number;
    /**
     * 
     * @type {number}
     * @memberof PagingOptions
     */
    'returnCount': number;
}
/**
 * 分納情報
 * @export
 * @interface PartialDelivery
 */
export interface PartialDelivery {
    /**
     * 発注ID
     * @type {string}
     * @memberof PartialDelivery
     */
    'orderId'?: string;
    /**
     * 分納ID
     * @type {string}
     * @memberof PartialDelivery
     */
    'partialDeliveryId'?: string;
    /**
     * 分納番号
     * @type {string}
     * @memberof PartialDelivery
     */
    'partialDeliveryNumber'?: string;
    /**
     * 分納作成日
     * @type {number}
     * @memberof PartialDelivery
     */
    'createdPartialDeliveryDate'?: number;
    /**
     * 分納入荷予定日
     * @type {number}
     * @memberof PartialDelivery
     */
    'partialDeliveryEstimatedTimeOfArrival'?: number;
    /**
     * 分納発注数量
     * @type {number}
     * @memberof PartialDelivery
     */
    'partialDeliveryAmount'?: number;
    /**
     * 分納発注ステータス
     * @type {string}
     * @memberof PartialDelivery
     */
    'partialDeliveryState'?: string;
    /**
     * 更新日時
     * @type {number}
     * @memberof PartialDelivery
     */
    'updateAt'?: number;
}
/**
 * 関連取引登録で投げる関連取引情報
 * @export
 * @interface PostInventoryRequestInfo
 */
export interface PostInventoryRequestInfo {
    /**
     * 
     * @type {string}
     * @memberof PostInventoryRequestInfo
     */
    'aggregateBusinessId': string;
    /**
     * 
     * @type {number}
     * @memberof PostInventoryRequestInfo
     */
    'inventoryTargetYear': number;
    /**
     * 
     * @type {number}
     * @memberof PostInventoryRequestInfo
     */
    'inventoryTargetMonth': number;
    /**
     * 
     * @type {number}
     * @memberof PostInventoryRequestInfo
     */
    'inventoriedDate': number;
    /**
     * 
     * @type {number}
     * @memberof PostInventoryRequestInfo
     */
    'inventoryAmount': number;
}
/**
 * postした時にレスポンスで受け取る情報の型定義
 * @export
 * @interface PostInventoryResponse
 */
export interface PostInventoryResponse {
    /**
     * 
     * @type {number}
     * @memberof PostInventoryResponse
     */
    'statusCode': number;
    /**
     * 
     * @type {number}
     * @memberof PostInventoryResponse
     */
    'code': number;
    /**
     * 
     * @type {string}
     * @memberof PostInventoryResponse
     */
    'message': string;
    /**
     * 
     * @type {PostInventoryResponseResult}
     * @memberof PostInventoryResponse
     */
    'result': PostInventoryResponseResult;
}
/**
 * 関連取引登録APIのレスポンスの型定義
 * @export
 * @interface PostInventoryResponseResult
 */
export interface PostInventoryResponseResult {
    /**
     * 
     * @type {string}
     * @memberof PostInventoryResponseResult
     */
    'InventoryId'?: string;
}
/**
 * 関連取引情報（モーダル表示用）
 * @export
 * @interface RelatedTransaction
 */
export interface RelatedTransaction {
    /**
     * 関連取引ID
     * @type {string}
     * @memberof RelatedTransaction
     */
    'baseBusinessId': string;
    /**
     * 売上先コード
     * @type {string}
     * @memberof RelatedTransaction
     */
    'customerNumber': string;
    /**
     * 売上先名
     * @type {string}
     * @memberof RelatedTransaction
     */
    'customerName': string;
    /**
     * 送り先コード
     * @type {string}
     * @memberof RelatedTransaction
     */
    'salesDestinationNumber': string;
    /**
     * 送り先名
     * @type {string}
     * @memberof RelatedTransaction
     */
    'salesDestinationName': string;
    /**
     * 販売実績リスト
     * @type {Array<RelatedTransactionSalesResult>}
     * @memberof RelatedTransaction
     */
    'salesResults': Array<RelatedTransactionSalesResult>;
    /**
     * 内示リスト
     * @type {Array<RelatedTransactionForecast>}
     * @memberof RelatedTransaction
     */
    'customerForecasts': Array<RelatedTransactionForecast>;
}
/**
 * 関連取引の内示情報
 * @export
 * @interface RelatedTransactionForecast
 */
export interface RelatedTransactionForecast {
    /**
     * 受領年
     * @type {number}
     * @memberof RelatedTransactionForecast
     */
    'receivedYear': number;
    /**
     * 受領月
     * @type {number}
     * @memberof RelatedTransactionForecast
     */
    'receivedMonth': number;
    /**
     * 対象年
     * @type {number}
     * @memberof RelatedTransactionForecast
     */
    'targetYear': number;
    /**
     * 対象月
     * @type {number}
     * @memberof RelatedTransactionForecast
     */
    'targetMonth': number;
    /**
     * 数量
     * @type {number}
     * @memberof RelatedTransactionForecast
     */
    'amount': number;
}
/**
 * 関連取引の販売実績情報
 * @export
 * @interface RelatedTransactionSalesResult
 */
export interface RelatedTransactionSalesResult {
    /**
     * 対象年
     * @type {number}
     * @memberof RelatedTransactionSalesResult
     */
    'targetYear': number;
    /**
     * 対象月
     * @type {number}
     * @memberof RelatedTransactionSalesResult
     */
    'targetMonth': number;
    /**
     * 数量
     * @type {number}
     * @memberof RelatedTransactionSalesResult
     */
    'amount': number;
}
/**
 * 販売実績
 * @export
 * @interface SalesResult
 */
export interface SalesResult {
    /**
     * 集計ID
     * @type {string}
     * @memberof SalesResult
     */
    'aggregateBusinessId'?: string;
    /**
     * 販売実績ID
     * @type {string}
     * @memberof SalesResult
     */
    'salesResultId'?: string;
    /**
     * 販売実績対象年
     * @type {number}
     * @memberof SalesResult
     */
    'targetYear'?: number;
    /**
     * 販売実績対象月
     * @type {number}
     * @memberof SalesResult
     */
    'targetMonth'?: number;
    /**
     * 販売数量
     * @type {number}
     * @memberof SalesResult
     */
    'salesResultAmount'?: number;
}
/**
 * ソート種別
 * @export
 * @enum {string}
 */

export const SortType = {
    Asc: 'ASC',
    Desc: 'DESC'
} as const;

export type SortType = typeof SortType[keyof typeof SortType];


/**
 * 成功レスポンス
 * @export
 * @interface SuccessResponse
 */
export interface SuccessResponse {
    /**
     * 
     * @type {number}
     * @memberof SuccessResponse
     */
    'statusCode': number;
    /**
     * 
     * @type {number}
     * @memberof SuccessResponse
     */
    'code': number;
    /**
     * 
     * @type {string}
     * @memberof SuccessResponse
     */
    'message': string;
    /**
     * 
     * @type {object}
     * @memberof SuccessResponse
     */
    'result': object;
}
/**
 * 集計取引の数値集計データ
 * @export
 * @interface SummaryData
 */
export interface SummaryData {
    /**
     * 入荷の数値集計データ
     * @type {Array<SummaryDataArrivalSummaryInner>}
     * @memberof SummaryData
     */
    'arrivalSummary'?: Array<SummaryDataArrivalSummaryInner>;
    /**
     * 客先内示の数値集計データ
     * @type {Array<SummaryDataCustomerForecastSummaryInner>}
     * @memberof SummaryData
     */
    'customerForecastSummary'?: Array<SummaryDataCustomerForecastSummaryInner>;
    /**
     * 在庫の数値集計データ
     * @type {Array<SummaryDataInventorySummaryInner>}
     * @memberof SummaryData
     */
    'inventorySummary'?: Array<SummaryDataInventorySummaryInner>;
    /**
     * 発注の数値集計データ
     * @type {Array<SummaryDataOrderSummaryInner>}
     * @memberof SummaryData
     */
    'orderSummary'?: Array<SummaryDataOrderSummaryInner>;
    /**
     * 販売実績の数値集計データ
     * @type {Array<SummaryDataSalesResultSummaryInner>}
     * @memberof SummaryData
     */
    'salesResultSummary'?: Array<SummaryDataSalesResultSummaryInner>;
}
/**
 * 
 * @export
 * @interface SummaryDataArrivalSummaryInner
 */
export interface SummaryDataArrivalSummaryInner {
    /**
     * 入荷数量の合計
     * @type {number}
     * @memberof SummaryDataArrivalSummaryInner
     */
    'arrivalAmountSummary': number;
    /**
     * 対象月
     * @type {number}
     * @memberof SummaryDataArrivalSummaryInner
     */
    'targetMonth': number;
    /**
     * 対象年
     * @type {number}
     * @memberof SummaryDataArrivalSummaryInner
     */
    'targetYear': number;
}
/**
 * 
 * @export
 * @interface SummaryDataCustomerForecastSummaryInner
 */
export interface SummaryDataCustomerForecastSummaryInner {
    /**
     * 客先内示数量の合計
     * @type {number}
     * @memberof SummaryDataCustomerForecastSummaryInner
     */
    'customerForecastAmountSummary': number;
    /**
     * 対象月
     * @type {number}
     * @memberof SummaryDataCustomerForecastSummaryInner
     */
    'targetMonth': number;
    /**
     * 対象年
     * @type {number}
     * @memberof SummaryDataCustomerForecastSummaryInner
     */
    'targetYear': number;
    /**
     * 受領月
     * @type {number}
     * @memberof SummaryDataCustomerForecastSummaryInner
     */
    'receivedMonth': number;
    /**
     * 受領年
     * @type {number}
     * @memberof SummaryDataCustomerForecastSummaryInner
     */
    'receivedYear': number;
}
/**
 * 
 * @export
 * @interface SummaryDataInventorySummaryInner
 */
export interface SummaryDataInventorySummaryInner {
    /**
     * 在庫数量の合計
     * @type {number}
     * @memberof SummaryDataInventorySummaryInner
     */
    'inventoryAmountSummary': number;
    /**
     * 対象月
     * @type {number}
     * @memberof SummaryDataInventorySummaryInner
     */
    'targetMonth': number;
    /**
     * 対象年
     * @type {number}
     * @memberof SummaryDataInventorySummaryInner
     */
    'targetYear': number;
}
/**
 * 
 * @export
 * @interface SummaryDataOrderSummaryInner
 */
export interface SummaryDataOrderSummaryInner {
    /**
     * 納入前の発注数量の合計
     * @type {number}
     * @memberof SummaryDataOrderSummaryInner
     */
    'preOrderAmountSummary'?: number;
    /**
     * 納入済みの発注数量の合計
     * @type {number}
     * @memberof SummaryDataOrderSummaryInner
     */
    'deliveredOrderAmountSummary'?: number;
    /**
     * 対象月
     * @type {number}
     * @memberof SummaryDataOrderSummaryInner
     */
    'targetMonth': number;
    /**
     * 対象年
     * @type {number}
     * @memberof SummaryDataOrderSummaryInner
     */
    'targetYear': number;
}
/**
 * 
 * @export
 * @interface SummaryDataSalesResultSummaryInner
 */
export interface SummaryDataSalesResultSummaryInner {
    /**
     * 販売実績数量の合計
     * @type {number}
     * @memberof SummaryDataSalesResultSummaryInner
     */
    'salesResultAmountSummary': number;
    /**
     * 対象月
     * @type {number}
     * @memberof SummaryDataSalesResultSummaryInner
     */
    'targetMonth': number;
    /**
     * 対象年
     * @type {number}
     * @memberof SummaryDataSalesResultSummaryInner
     */
    'targetYear': number;
}
/**
 * 仕入先内示情報
 * @export
 * @interface SupplierAnnounce
 */
export interface SupplierAnnounce {
    /**
     * 仕入先内示ID
     * @type {string}
     * @memberof SupplierAnnounce
     */
    'supplierForecastId': string;
    /**
     * 仕入先内示作成年
     * @type {number}
     * @memberof SupplierAnnounce
     */
    'supplierForecastCreatedYear': number;
    /**
     * 仕入先内示作成月
     * @type {number}
     * @memberof SupplierAnnounce
     */
    'supplierForecastCreatedMonth': number;
    /**
     * 仕入先内示対象年
     * @type {number}
     * @memberof SupplierAnnounce
     */
    'supplierForecastTargetYear': number;
    /**
     * 仕入先内示対象月
     * @type {number}
     * @memberof SupplierAnnounce
     */
    'supplierForecastTargetMonth': number;
    /**
     * 仕入先内示数量
     * @type {number}
     * @memberof SupplierAnnounce
     */
    'supplierForecastAmount': number;
}
/**
 * 数値情報
 * @export
 * @interface TransactionInfo
 */
export interface TransactionInfo {
    /**
     * 数値のタイプ
     * @type {string}
     * @memberof TransactionInfo
     */
    'transactionType': string;
    /**
     * 数量
     * @type {number}
     * @memberof TransactionInfo
     */
    'amount': number;
    /**
     * 対象年
     * @type {number}
     * @memberof TransactionInfo
     */
    'targetYear': number;
    /**
     * 対象月
     * @type {number}
     * @memberof TransactionInfo
     */
    'targetMonth': number;
    /**
     * 関連取引ID
     * @type {string}
     * @memberof TransactionInfo
     */
    'baseBusinessId'?: string;
    /**
     * 受領年
     * @type {number}
     * @memberof TransactionInfo
     */
    'receivedYear'?: number;
    /**
     * 受領月
     * @type {number}
     * @memberof TransactionInfo
     */
    'receivedMonth'?: number;
}
/**
 * リクエストに含めるフィルター項目の型
 * @export
 * @interface UseFilterItem
 */
export interface UseFilterItem {
    /**
     * 置場CD
     * @type {string}
     * @memberof UseFilterItem
     */
    'warehouseNumber'?: string;
    /**
     * 置場名
     * @type {string}
     * @memberof UseFilterItem
     */
    'warehouse'?: string;
    /**
     * 仕入先CD
     * @type {string}
     * @memberof UseFilterItem
     */
    'supplierNumber'?: string;
    /**
     * 仕入先名
     * @type {string}
     * @memberof UseFilterItem
     */
    'supplierName'?: string;
    /**
     * 商品CD
     * @type {string}
     * @memberof UseFilterItem
     */
    'businessNumber'?: string;
    /**
     * 商品名
     * @type {string}
     * @memberof UseFilterItem
     */
    'businessName'?: string;
    /**
     * 容量
     * @type {number}
     * @memberof UseFilterItem
     */
    'package'?: number;
    /**
     * 単位
     * @type {string}
     * @memberof UseFilterItem
     */
    'unit'?: string;
    /**
     * MOQ
     * @type {number}
     * @memberof UseFilterItem
     */
    'moq'?: number;
    /**
     * 製造社
     * @type {string}
     * @memberof UseFilterItem
     */
    'manufacturer'?: string;
    /**
     * 集計取引担当者ID
     * @type {string}
     * @memberof UseFilterItem
     */
    'aggregateBusinessResponsibleUserId'?: string;
    /**
     * 発注単位
     * @type {string}
     * @memberof UseFilterItem
     */
    'orderPackage'?: string;
    /**
     * 売上先CD
     * @type {string}
     * @memberof UseFilterItem
     */
    'customerNumber'?: string;
    /**
     * 売上先名
     * @type {string}
     * @memberof UseFilterItem
     */
    'customerName'?: string;
    /**
     * 送り先CD
     * @type {string}
     * @memberof UseFilterItem
     */
    'salesDestinationNumber'?: string;
    /**
     * 送り先名
     * @type {string}
     * @memberof UseFilterItem
     */
    'salesDestinationName'?: string;
    /**
     * エンドユーザー
     * @type {string}
     * @memberof UseFilterItem
     */
    'endUser'?: string;
    /**
     * 関連取引担当者ID
     * @type {string}
     * @memberof UseFilterItem
     */
    'baseBusinessResponsibleUserId'?: string;
    /**
     * グループID
     * @type {string}
     * @memberof UseFilterItem
     */
    'groupId'?: string;
}
/**
 * ユーザーデータ
 * @export
 * @interface UserData
 */
export interface UserData {
    /**
     * 
     * @type {string}
     * @memberof UserData
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserData
     */
    'name'?: string;
}
/**
 * 年月を表すオブジェクト
 * @export
 * @interface YearMonth
 */
export interface YearMonth {
    /**
     * 年
     * @type {number}
     * @memberof YearMonth
     */
    'year': number;
    /**
     * 月（1-12）
     * @type {number}
     * @memberof YearMonth
     */
    'month': number;
}

/**
 * InventoryApi - axios parameter creator
 * @export
 */
export const InventoryApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 入荷情報を一括で修正する
         * @param {BulkModifyArrivalRequest} bulkModifyArrivalRequest 修正する在庫情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkModifyArrival: async (bulkModifyArrivalRequest: BulkModifyArrivalRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bulkModifyArrivalRequest' is not null or undefined
            assertParamExists('bulkModifyArrival', 'bulkModifyArrivalRequest', bulkModifyArrivalRequest)
            const localVarPath = `/bulk-modify-arrival`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bulkModifyArrivalRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 数値情報を一括で修正する
         * @param {BulkModifyTransactionRequest} bulkModifyTransactionRequest 修正する情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkModifyTransaction: async (bulkModifyTransactionRequest: BulkModifyTransactionRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bulkModifyTransactionRequest' is not null or undefined
            assertParamExists('bulkModifyTransaction', 'bulkModifyTransactionRequest', bulkModifyTransactionRequest)
            const localVarPath = `/bulk-modify-transaction`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bulkModifyTransactionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 在庫表の内容をExcelでExportする（テンプレートベース）
         * @param {ExportInventoryExcelRequest} exportInventoryExcelRequest Excelエクスポートのテンプレート設定
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportInventoryBusiness: async (exportInventoryExcelRequest: ExportInventoryExcelRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'exportInventoryExcelRequest' is not null or undefined
            assertParamExists('exportInventoryBusiness', 'exportInventoryExcelRequest', exportInventoryExcelRequest)
            const localVarPath = `/export-inventory-business`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(exportInventoryExcelRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 在庫情報を取得する
         * @param {SortType} sortType ソートの種類（asc/desc）
         * @param {number} limit 情報の表示最大数
         * @param {number} offset 表示する情報のオフセット
         * @param {string} earlyPeriod 表示期間のスタート
         * @param {string} latterPeriod 表示期間の終わり
         * @param {string} [sortTarget] ソート対象のカラム名
         * @param {UseFilterItem} [filterItem] フィルター対象の項目と情報
         * @param {string} [getInfoOptions] APIで必要な情報を設定するためのオプション項目。型は文字列型で、カンマ区切りで必要な情報を指定する。指定された情報(数量情報)を取得して返すようにしている。順不同でもOK。
         * @param {ObjectFilterInfo} [filterItemObject] フィルター項目の内、Objectで指定する必要があるもの(単位と値がセットで指定されるもの)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInventory: async (sortType: SortType, limit: number, offset: number, earlyPeriod: string, latterPeriod: string, sortTarget?: string, filterItem?: UseFilterItem, getInfoOptions?: string, filterItemObject?: ObjectFilterInfo, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sortType' is not null or undefined
            assertParamExists('getInventory', 'sortType', sortType)
            // verify required parameter 'limit' is not null or undefined
            assertParamExists('getInventory', 'limit', limit)
            // verify required parameter 'offset' is not null or undefined
            assertParamExists('getInventory', 'offset', offset)
            // verify required parameter 'earlyPeriod' is not null or undefined
            assertParamExists('getInventory', 'earlyPeriod', earlyPeriod)
            // verify required parameter 'latterPeriod' is not null or undefined
            assertParamExists('getInventory', 'latterPeriod', latterPeriod)
            const localVarPath = `/inventory`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (sortType !== undefined) {
                localVarQueryParameter['sort_type'] = sortType;
            }

            if (sortTarget !== undefined) {
                localVarQueryParameter['sort_target'] = sortTarget;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (earlyPeriod !== undefined) {
                localVarQueryParameter['early_period'] = (earlyPeriod as any instanceof Date) ?
                    (earlyPeriod as any).toISOString().substring(0,10) :
                    earlyPeriod;
            }

            if (latterPeriod !== undefined) {
                localVarQueryParameter['latter_period'] = (latterPeriod as any instanceof Date) ?
                    (latterPeriod as any).toISOString().substring(0,10) :
                    latterPeriod;
            }

            if (filterItem !== undefined) {
                for (const [key, value] of Object.entries(filterItem)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (getInfoOptions !== undefined) {
                localVarQueryParameter['get_info_options'] = getInfoOptions;
            }

            if (filterItemObject !== undefined) {
                for (const [key, value] of Object.entries(filterItemObject)) {
                    localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 在庫分析情報(集計)取得API
         * @param {string} [sortType] ソート向き
         * @param {string} [sortTarget] ソート対象
         * @param {number} [limit] 一度に取得する上限
         * @param {number} [offset] オフセット
         * @param {string} [metricType] 
         * @param {string} [dimensionType] 
         * @param {number} [targetYear] 対象年
         * @param {number} [targetMonth] 対象月
         * @param {number} [targetPeriodFromYear] 対象期間年(from)
         * @param {number} [targetPeriodFromMonth] 対象期間月(from)
         * @param {number} [targetPeriodToYear] 対象期間年(to)
         * @param {number} [targetPeriodToMonth] 対象期間月(to)
         * @param {number} [forecastAccuracyConsiderationMonths] 内示正答率考慮期間
         * @param {UseFilterItem} [filterItem] フィルター対象の項目と情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInventoryAnalyticsByDimensionAggregateBusiness: async (sortType?: string, sortTarget?: string, limit?: number, offset?: number, metricType?: string, dimensionType?: string, targetYear?: number, targetMonth?: number, targetPeriodFromYear?: number, targetPeriodFromMonth?: number, targetPeriodToYear?: number, targetPeriodToMonth?: number, forecastAccuracyConsiderationMonths?: number, filterItem?: UseFilterItem, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/inventory/analytics/by-dimension/aggregate-business`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (sortType !== undefined) {
                localVarQueryParameter['sortType'] = sortType;
            }

            if (sortTarget !== undefined) {
                localVarQueryParameter['sortTarget'] = sortTarget;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (metricType !== undefined) {
                localVarQueryParameter['metricType'] = metricType;
            }

            if (dimensionType !== undefined) {
                localVarQueryParameter['dimensionType'] = dimensionType;
            }

            if (targetYear !== undefined) {
                localVarQueryParameter['targetYear'] = targetYear;
            }

            if (targetMonth !== undefined) {
                localVarQueryParameter['targetMonth'] = targetMonth;
            }

            if (targetPeriodFromYear !== undefined) {
                localVarQueryParameter['targetPeriodFromYear'] = targetPeriodFromYear;
            }

            if (targetPeriodFromMonth !== undefined) {
                localVarQueryParameter['targetPeriodFromMonth'] = targetPeriodFromMonth;
            }

            if (targetPeriodToYear !== undefined) {
                localVarQueryParameter['targetPeriodToYear'] = targetPeriodToYear;
            }

            if (targetPeriodToMonth !== undefined) {
                localVarQueryParameter['targetPeriodToMonth'] = targetPeriodToMonth;
            }

            if (forecastAccuracyConsiderationMonths !== undefined) {
                localVarQueryParameter['forecastAccuracyConsiderationMonths'] = forecastAccuracyConsiderationMonths;
            }

            if (filterItem !== undefined) {
                for (const [key, value] of Object.entries(filterItem)) {
                    localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 在庫分析情報(取引)取得API
         * @param {string} [sortType] ソート向き
         * @param {string} [sortTarget] ソート対象
         * @param {number} [limit] 一度に取得する上限
         * @param {number} [offset] オフセット
         * @param {string} [metricType] 
         * @param {string} [dimensionType] 
         * @param {number} [targetYear] 対象年
         * @param {number} [targetMonth] 対象月
         * @param {number} [targetPeriodFromYear] 対象期間年(from)
         * @param {number} [targetPeriodFromMonth] 対象期間月(from)
         * @param {number} [targetPeriodToYear] 対象期間年(to)
         * @param {number} [targetPeriodToMonth] 対象期間月(to)
         * @param {UseFilterItem} [filterItem] フィルター対象の項目と情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInventoryAnalyticsByDimensionBaseBusiness: async (sortType?: string, sortTarget?: string, limit?: number, offset?: number, metricType?: string, dimensionType?: string, targetYear?: number, targetMonth?: number, targetPeriodFromYear?: number, targetPeriodFromMonth?: number, targetPeriodToYear?: number, targetPeriodToMonth?: number, filterItem?: UseFilterItem, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/inventory/analytics/by-dimension/base-business`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (sortType !== undefined) {
                localVarQueryParameter['sortType'] = sortType;
            }

            if (sortTarget !== undefined) {
                localVarQueryParameter['sortTarget'] = sortTarget;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (metricType !== undefined) {
                localVarQueryParameter['metricType'] = metricType;
            }

            if (dimensionType !== undefined) {
                localVarQueryParameter['dimensionType'] = dimensionType;
            }

            if (targetYear !== undefined) {
                localVarQueryParameter['targetYear'] = targetYear;
            }

            if (targetMonth !== undefined) {
                localVarQueryParameter['targetMonth'] = targetMonth;
            }

            if (targetPeriodFromYear !== undefined) {
                localVarQueryParameter['targetPeriodFromYear'] = targetPeriodFromYear;
            }

            if (targetPeriodFromMonth !== undefined) {
                localVarQueryParameter['targetPeriodFromMonth'] = targetPeriodFromMonth;
            }

            if (targetPeriodToYear !== undefined) {
                localVarQueryParameter['targetPeriodToYear'] = targetPeriodToYear;
            }

            if (targetPeriodToMonth !== undefined) {
                localVarQueryParameter['targetPeriodToMonth'] = targetPeriodToMonth;
            }

            if (filterItem !== undefined) {
                for (const [key, value] of Object.entries(filterItem)) {
                    localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 在庫分析詳細情報(集計)取得API
         * @param {string} [sortType] ソート向き
         * @param {string} [sortTarget] ソート対象
         * @param {number} [limit] 一度に取得する上限
         * @param {number} [offset] オフセット
         * @param {UseFilterItem} [filterItem] フィルター対象の項目と情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInventoryAnalyticsDetailsAggregatebusiness: async (sortType?: string, sortTarget?: string, limit?: number, offset?: number, filterItem?: UseFilterItem, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/inventory/analytics/details/aggregate-business`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (sortType !== undefined) {
                localVarQueryParameter['sortType'] = sortType;
            }

            if (sortTarget !== undefined) {
                localVarQueryParameter['sortTarget'] = sortTarget;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (filterItem !== undefined) {
                for (const [key, value] of Object.entries(filterItem)) {
                    localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 在庫分析詳細情報(在庫ゼロ予測の集計)取得API
         * @param {GetInventoryAnalyticsDetailsAggregatebusinessWithAlertSeverityEnum} severity 取得するアラートの重大さ
         * @param {GetInventoryAnalyticsDetailsAggregatebusinessWithAlertDirectionEnum} direction 取得するアラートの向き
         * @param {string} [sortType] ソート向き
         * @param {string} [sortTarget] ソート対象
         * @param {number} [limit] 一度に取得する上限
         * @param {number} [offset] オフセット
         * @param {string} [alertFilterInfo] アラートのフィルタ情報
         * @param {UseFilterItem} [filterItem] フィルター対象の項目と情報
         * @param {string} [excessConsecutiveMonths] 過剰の設定パラメータ
         * @param {string} [excessRatioThreshold] 過剰の設定パラメータ
         * @param {string} [excessMomChangeRateThreshold] 過剰の設定パラメータ
         * @param {string} [excessMinQuantityThreshold] 過剰の設定パラメータ
         * @param {string} [shortageConsecutiveMonths] 不足の設定パラメータ
         * @param {string} [shortageRatioThreshold] 不足の設定パラメータ
         * @param {string} [shortageMomChangeRateThreshold] 不足の設定パラメータ
         * @param {string} [shortageMinQuantityThreshold] 不足の設定パラメータ
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInventoryAnalyticsDetailsAggregatebusinessWithAlert: async (severity: GetInventoryAnalyticsDetailsAggregatebusinessWithAlertSeverityEnum, direction: GetInventoryAnalyticsDetailsAggregatebusinessWithAlertDirectionEnum, sortType?: string, sortTarget?: string, limit?: number, offset?: number, alertFilterInfo?: string, filterItem?: UseFilterItem, excessConsecutiveMonths?: string, excessRatioThreshold?: string, excessMomChangeRateThreshold?: string, excessMinQuantityThreshold?: string, shortageConsecutiveMonths?: string, shortageRatioThreshold?: string, shortageMomChangeRateThreshold?: string, shortageMinQuantityThreshold?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'severity' is not null or undefined
            assertParamExists('getInventoryAnalyticsDetailsAggregatebusinessWithAlert', 'severity', severity)
            // verify required parameter 'direction' is not null or undefined
            assertParamExists('getInventoryAnalyticsDetailsAggregatebusinessWithAlert', 'direction', direction)
            const localVarPath = `/inventory/analytics/details/aggregate-business-with-alert`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (sortType !== undefined) {
                localVarQueryParameter['sortType'] = sortType;
            }

            if (sortTarget !== undefined) {
                localVarQueryParameter['sortTarget'] = sortTarget;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (severity !== undefined) {
                localVarQueryParameter['severity'] = severity;
            }

            if (direction !== undefined) {
                localVarQueryParameter['direction'] = direction;
            }

            if (alertFilterInfo !== undefined) {
                localVarQueryParameter['alertFilterInfo'] = alertFilterInfo;
            }

            if (filterItem !== undefined) {
                for (const [key, value] of Object.entries(filterItem)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (excessConsecutiveMonths !== undefined) {
                localVarQueryParameter['excess-consecutiveMonths'] = excessConsecutiveMonths;
            }

            if (excessRatioThreshold !== undefined) {
                localVarQueryParameter['excess-ratioThreshold'] = excessRatioThreshold;
            }

            if (excessMomChangeRateThreshold !== undefined) {
                localVarQueryParameter['excess-momChangeRateThreshold'] = excessMomChangeRateThreshold;
            }

            if (excessMinQuantityThreshold !== undefined) {
                localVarQueryParameter['excess-minQuantityThreshold'] = excessMinQuantityThreshold;
            }

            if (shortageConsecutiveMonths !== undefined) {
                localVarQueryParameter['shortage-consecutiveMonths'] = shortageConsecutiveMonths;
            }

            if (shortageRatioThreshold !== undefined) {
                localVarQueryParameter['shortage-ratioThreshold'] = shortageRatioThreshold;
            }

            if (shortageMomChangeRateThreshold !== undefined) {
                localVarQueryParameter['shortage-momChangeRateThreshold'] = shortageMomChangeRateThreshold;
            }

            if (shortageMinQuantityThreshold !== undefined) {
                localVarQueryParameter['shortage-minQuantityThreshold'] = shortageMinQuantityThreshold;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 在庫分析詳細情報(取引)取得API
         * @param {string} [sortType] ソート向き
         * @param {string} [sortTarget] ソート対象
         * @param {number} [limit] 一度に取得する上限
         * @param {number} [offset] オフセット
         * @param {boolean} [isExcludeNoAccuracy] 内示正答率がない取引を省くかどうか
         * @param {UseFilterItem} [filterItem] フィルター対象の項目と情報
         * @param {string} [forecastForReceiptName] フィルターする受領用内示名
         * @param {string} [forecastForReceiptResponsibleUserId] フィルターする受領用内示担当者ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInventoryAnalyticsDetailsBaseBusiness: async (sortType?: string, sortTarget?: string, limit?: number, offset?: number, isExcludeNoAccuracy?: boolean, filterItem?: UseFilterItem, forecastForReceiptName?: string, forecastForReceiptResponsibleUserId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/inventory/analytics/details/base-business`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (sortType !== undefined) {
                localVarQueryParameter['sortType'] = sortType;
            }

            if (sortTarget !== undefined) {
                localVarQueryParameter['sortTarget'] = sortTarget;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (isExcludeNoAccuracy !== undefined) {
                localVarQueryParameter['isExcludeNoAccuracy'] = isExcludeNoAccuracy;
            }

            if (filterItem !== undefined) {
                for (const [key, value] of Object.entries(filterItem)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (forecastForReceiptName !== undefined) {
                localVarQueryParameter['forecastForReceiptName'] = forecastForReceiptName;
            }

            if (forecastForReceiptResponsibleUserId !== undefined) {
                localVarQueryParameter['forecastForReceiptResponsibleUserId'] = forecastForReceiptResponsibleUserId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 在庫分析概要情報取得API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInventoryAnalyticsOverview: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/inventory/analytics/overview`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 集計行IDを参考に子取引を取得する
         * @param {SortType} sortType ソートの種類（asc/desc）
         * @param {number} limit 情報の表示最大数
         * @param {number} offset 表示する情報のオフセット
         * @param {string} aggregateBusinessId 集計取引ID
         * @param {string} earlyPeriod 表示期間のスタート(Date型)
         * @param {string} latterPeriod 表示期間の終わり(Date型)
         * @param {UseFilterItem} [filterItem] フィルター対象の項目と情報
         * @param {string} [getInfoOptions] APIで必要な情報を設定するためのオプション項目。型は文字列型で、カンマ区切りで必要な情報を指定する。指定された情報(数量情報)を取得して返すようにしている。順不同でもOK。
         * @param {ObjectFilterInfo} [filterItemObject] フィルター項目の内、Objectで指定する必要があるもの(単位と値がセットで指定されるもの)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInventoryBusiness: async (sortType: SortType, limit: number, offset: number, aggregateBusinessId: string, earlyPeriod: string, latterPeriod: string, filterItem?: UseFilterItem, getInfoOptions?: string, filterItemObject?: ObjectFilterInfo, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sortType' is not null or undefined
            assertParamExists('getInventoryBusiness', 'sortType', sortType)
            // verify required parameter 'limit' is not null or undefined
            assertParamExists('getInventoryBusiness', 'limit', limit)
            // verify required parameter 'offset' is not null or undefined
            assertParamExists('getInventoryBusiness', 'offset', offset)
            // verify required parameter 'aggregateBusinessId' is not null or undefined
            assertParamExists('getInventoryBusiness', 'aggregateBusinessId', aggregateBusinessId)
            // verify required parameter 'earlyPeriod' is not null or undefined
            assertParamExists('getInventoryBusiness', 'earlyPeriod', earlyPeriod)
            // verify required parameter 'latterPeriod' is not null or undefined
            assertParamExists('getInventoryBusiness', 'latterPeriod', latterPeriod)
            const localVarPath = `/inventory-business`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (sortType !== undefined) {
                localVarQueryParameter['sort_type'] = sortType;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (aggregateBusinessId !== undefined) {
                localVarQueryParameter['aggregate_business_id'] = aggregateBusinessId;
            }

            if (earlyPeriod !== undefined) {
                localVarQueryParameter['early_period'] = (earlyPeriod as any instanceof Date) ?
                    (earlyPeriod as any).toISOString().substring(0,10) :
                    earlyPeriod;
            }

            if (latterPeriod !== undefined) {
                localVarQueryParameter['latter_period'] = (latterPeriod as any instanceof Date) ?
                    (latterPeriod as any).toISOString().substring(0,10) :
                    latterPeriod;
            }

            if (filterItem !== undefined) {
                for (const [key, value] of Object.entries(filterItem)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (getInfoOptions !== undefined) {
                localVarQueryParameter['get_info_options'] = getInfoOptions;
            }

            if (filterItemObject !== undefined) {
                for (const [key, value] of Object.entries(filterItemObject)) {
                    localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 集計取引IDに紐づく関連取引の販売実績・内示データを取得する（モーダル表示用）
         * @param {string} aggregateBusinessId 集計取引ID
         * @param {number} startYear 開始年
         * @param {number} startMonth 開始月
         * @param {number} endYear 終了年
         * @param {number} endMonth 終了月
         * @param {number} [receiptMonthOffset] 受領月オフセット（Nヶ月前内示を指定する）
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRelatedTransactionsDetail: async (aggregateBusinessId: string, startYear: number, startMonth: number, endYear: number, endMonth: number, receiptMonthOffset?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'aggregateBusinessId' is not null or undefined
            assertParamExists('getRelatedTransactionsDetail', 'aggregateBusinessId', aggregateBusinessId)
            // verify required parameter 'startYear' is not null or undefined
            assertParamExists('getRelatedTransactionsDetail', 'startYear', startYear)
            // verify required parameter 'startMonth' is not null or undefined
            assertParamExists('getRelatedTransactionsDetail', 'startMonth', startMonth)
            // verify required parameter 'endYear' is not null or undefined
            assertParamExists('getRelatedTransactionsDetail', 'endYear', endYear)
            // verify required parameter 'endMonth' is not null or undefined
            assertParamExists('getRelatedTransactionsDetail', 'endMonth', endMonth)
            const localVarPath = `/aggregate-business/{aggregateBusinessId}/related-transactions-detail`
                .replace(`{${"aggregateBusinessId"}}`, encodeURIComponent(String(aggregateBusinessId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (startYear !== undefined) {
                localVarQueryParameter['startYear'] = startYear;
            }

            if (startMonth !== undefined) {
                localVarQueryParameter['startMonth'] = startMonth;
            }

            if (endYear !== undefined) {
                localVarQueryParameter['endYear'] = endYear;
            }

            if (endMonth !== undefined) {
                localVarQueryParameter['endMonth'] = endMonth;
            }

            if (receiptMonthOffset !== undefined) {
                localVarQueryParameter['receiptMonthOffset'] = receiptMonthOffset;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 在庫テーブルに情報を登録する
         * @param {InventoryPostRequest} inventoryPostRequest 登録する在庫テーブル情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inventoryPost: async (inventoryPostRequest: InventoryPostRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'inventoryPostRequest' is not null or undefined
            assertParamExists('inventoryPost', 'inventoryPostRequest', inventoryPostRequest)
            const localVarPath = `/inventory`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(inventoryPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * InventoryApi - functional programming interface
 * @export
 */
export const InventoryApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = InventoryApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 入荷情報を一括で修正する
         * @param {BulkModifyArrivalRequest} bulkModifyArrivalRequest 修正する在庫情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bulkModifyArrival(bulkModifyArrivalRequest: BulkModifyArrivalRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BulkModifyArrivalResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bulkModifyArrival(bulkModifyArrivalRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InventoryApi.bulkModifyArrival']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 数値情報を一括で修正する
         * @param {BulkModifyTransactionRequest} bulkModifyTransactionRequest 修正する情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bulkModifyTransaction(bulkModifyTransactionRequest: BulkModifyTransactionRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bulkModifyTransaction(bulkModifyTransactionRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InventoryApi.bulkModifyTransaction']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 在庫表の内容をExcelでExportする（テンプレートベース）
         * @param {ExportInventoryExcelRequest} exportInventoryExcelRequest Excelエクスポートのテンプレート設定
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportInventoryBusiness(exportInventoryExcelRequest: ExportInventoryExcelRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExportInventoryBusinessSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exportInventoryBusiness(exportInventoryExcelRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InventoryApi.exportInventoryBusiness']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 在庫情報を取得する
         * @param {SortType} sortType ソートの種類（asc/desc）
         * @param {number} limit 情報の表示最大数
         * @param {number} offset 表示する情報のオフセット
         * @param {string} earlyPeriod 表示期間のスタート
         * @param {string} latterPeriod 表示期間の終わり
         * @param {string} [sortTarget] ソート対象のカラム名
         * @param {UseFilterItem} [filterItem] フィルター対象の項目と情報
         * @param {string} [getInfoOptions] APIで必要な情報を設定するためのオプション項目。型は文字列型で、カンマ区切りで必要な情報を指定する。指定された情報(数量情報)を取得して返すようにしている。順不同でもOK。
         * @param {ObjectFilterInfo} [filterItemObject] フィルター項目の内、Objectで指定する必要があるもの(単位と値がセットで指定されるもの)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getInventory(sortType: SortType, limit: number, offset: number, earlyPeriod: string, latterPeriod: string, sortTarget?: string, filterItem?: UseFilterItem, getInfoOptions?: string, filterItemObject?: ObjectFilterInfo, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetInventorySuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getInventory(sortType, limit, offset, earlyPeriod, latterPeriod, sortTarget, filterItem, getInfoOptions, filterItemObject, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InventoryApi.getInventory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 在庫分析情報(集計)取得API
         * @param {string} [sortType] ソート向き
         * @param {string} [sortTarget] ソート対象
         * @param {number} [limit] 一度に取得する上限
         * @param {number} [offset] オフセット
         * @param {string} [metricType] 
         * @param {string} [dimensionType] 
         * @param {number} [targetYear] 対象年
         * @param {number} [targetMonth] 対象月
         * @param {number} [targetPeriodFromYear] 対象期間年(from)
         * @param {number} [targetPeriodFromMonth] 対象期間月(from)
         * @param {number} [targetPeriodToYear] 対象期間年(to)
         * @param {number} [targetPeriodToMonth] 対象期間月(to)
         * @param {number} [forecastAccuracyConsiderationMonths] 内示正答率考慮期間
         * @param {UseFilterItem} [filterItem] フィルター対象の項目と情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getInventoryAnalyticsByDimensionAggregateBusiness(sortType?: string, sortTarget?: string, limit?: number, offset?: number, metricType?: string, dimensionType?: string, targetYear?: number, targetMonth?: number, targetPeriodFromYear?: number, targetPeriodFromMonth?: number, targetPeriodToYear?: number, targetPeriodToMonth?: number, forecastAccuracyConsiderationMonths?: number, filterItem?: UseFilterItem, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetInventoryAnalyticsByDimensionAggregateBusinessSuccessInner>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getInventoryAnalyticsByDimensionAggregateBusiness(sortType, sortTarget, limit, offset, metricType, dimensionType, targetYear, targetMonth, targetPeriodFromYear, targetPeriodFromMonth, targetPeriodToYear, targetPeriodToMonth, forecastAccuracyConsiderationMonths, filterItem, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InventoryApi.getInventoryAnalyticsByDimensionAggregateBusiness']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 在庫分析情報(取引)取得API
         * @param {string} [sortType] ソート向き
         * @param {string} [sortTarget] ソート対象
         * @param {number} [limit] 一度に取得する上限
         * @param {number} [offset] オフセット
         * @param {string} [metricType] 
         * @param {string} [dimensionType] 
         * @param {number} [targetYear] 対象年
         * @param {number} [targetMonth] 対象月
         * @param {number} [targetPeriodFromYear] 対象期間年(from)
         * @param {number} [targetPeriodFromMonth] 対象期間月(from)
         * @param {number} [targetPeriodToYear] 対象期間年(to)
         * @param {number} [targetPeriodToMonth] 対象期間月(to)
         * @param {UseFilterItem} [filterItem] フィルター対象の項目と情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getInventoryAnalyticsByDimensionBaseBusiness(sortType?: string, sortTarget?: string, limit?: number, offset?: number, metricType?: string, dimensionType?: string, targetYear?: number, targetMonth?: number, targetPeriodFromYear?: number, targetPeriodFromMonth?: number, targetPeriodToYear?: number, targetPeriodToMonth?: number, filterItem?: UseFilterItem, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetInventoryAnalyticsByDimensionBaseBusinessSuccessInner>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getInventoryAnalyticsByDimensionBaseBusiness(sortType, sortTarget, limit, offset, metricType, dimensionType, targetYear, targetMonth, targetPeriodFromYear, targetPeriodFromMonth, targetPeriodToYear, targetPeriodToMonth, filterItem, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InventoryApi.getInventoryAnalyticsByDimensionBaseBusiness']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 在庫分析詳細情報(集計)取得API
         * @param {string} [sortType] ソート向き
         * @param {string} [sortTarget] ソート対象
         * @param {number} [limit] 一度に取得する上限
         * @param {number} [offset] オフセット
         * @param {UseFilterItem} [filterItem] フィルター対象の項目と情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getInventoryAnalyticsDetailsAggregatebusiness(sortType?: string, sortTarget?: string, limit?: number, offset?: number, filterItem?: UseFilterItem, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetInventoryAnalyticsDetailAggregateBusinessSuccessInner>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getInventoryAnalyticsDetailsAggregatebusiness(sortType, sortTarget, limit, offset, filterItem, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InventoryApi.getInventoryAnalyticsDetailsAggregatebusiness']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 在庫分析詳細情報(在庫ゼロ予測の集計)取得API
         * @param {GetInventoryAnalyticsDetailsAggregatebusinessWithAlertSeverityEnum} severity 取得するアラートの重大さ
         * @param {GetInventoryAnalyticsDetailsAggregatebusinessWithAlertDirectionEnum} direction 取得するアラートの向き
         * @param {string} [sortType] ソート向き
         * @param {string} [sortTarget] ソート対象
         * @param {number} [limit] 一度に取得する上限
         * @param {number} [offset] オフセット
         * @param {string} [alertFilterInfo] アラートのフィルタ情報
         * @param {UseFilterItem} [filterItem] フィルター対象の項目と情報
         * @param {string} [excessConsecutiveMonths] 過剰の設定パラメータ
         * @param {string} [excessRatioThreshold] 過剰の設定パラメータ
         * @param {string} [excessMomChangeRateThreshold] 過剰の設定パラメータ
         * @param {string} [excessMinQuantityThreshold] 過剰の設定パラメータ
         * @param {string} [shortageConsecutiveMonths] 不足の設定パラメータ
         * @param {string} [shortageRatioThreshold] 不足の設定パラメータ
         * @param {string} [shortageMomChangeRateThreshold] 不足の設定パラメータ
         * @param {string} [shortageMinQuantityThreshold] 不足の設定パラメータ
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getInventoryAnalyticsDetailsAggregatebusinessWithAlert(severity: GetInventoryAnalyticsDetailsAggregatebusinessWithAlertSeverityEnum, direction: GetInventoryAnalyticsDetailsAggregatebusinessWithAlertDirectionEnum, sortType?: string, sortTarget?: string, limit?: number, offset?: number, alertFilterInfo?: string, filterItem?: UseFilterItem, excessConsecutiveMonths?: string, excessRatioThreshold?: string, excessMomChangeRateThreshold?: string, excessMinQuantityThreshold?: string, shortageConsecutiveMonths?: string, shortageRatioThreshold?: string, shortageMomChangeRateThreshold?: string, shortageMinQuantityThreshold?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetInventoryAnalyticsDetailAggregateBusinessWithAlertSuccessInner>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getInventoryAnalyticsDetailsAggregatebusinessWithAlert(severity, direction, sortType, sortTarget, limit, offset, alertFilterInfo, filterItem, excessConsecutiveMonths, excessRatioThreshold, excessMomChangeRateThreshold, excessMinQuantityThreshold, shortageConsecutiveMonths, shortageRatioThreshold, shortageMomChangeRateThreshold, shortageMinQuantityThreshold, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InventoryApi.getInventoryAnalyticsDetailsAggregatebusinessWithAlert']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 在庫分析詳細情報(取引)取得API
         * @param {string} [sortType] ソート向き
         * @param {string} [sortTarget] ソート対象
         * @param {number} [limit] 一度に取得する上限
         * @param {number} [offset] オフセット
         * @param {boolean} [isExcludeNoAccuracy] 内示正答率がない取引を省くかどうか
         * @param {UseFilterItem} [filterItem] フィルター対象の項目と情報
         * @param {string} [forecastForReceiptName] フィルターする受領用内示名
         * @param {string} [forecastForReceiptResponsibleUserId] フィルターする受領用内示担当者ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getInventoryAnalyticsDetailsBaseBusiness(sortType?: string, sortTarget?: string, limit?: number, offset?: number, isExcludeNoAccuracy?: boolean, filterItem?: UseFilterItem, forecastForReceiptName?: string, forecastForReceiptResponsibleUserId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetInventoryAnalyticsDetailBaseBusinessSuccessInner>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getInventoryAnalyticsDetailsBaseBusiness(sortType, sortTarget, limit, offset, isExcludeNoAccuracy, filterItem, forecastForReceiptName, forecastForReceiptResponsibleUserId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InventoryApi.getInventoryAnalyticsDetailsBaseBusiness']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 在庫分析概要情報取得API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getInventoryAnalyticsOverview(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetInventoryAnalyticsOverviewSuccessInner>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getInventoryAnalyticsOverview(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InventoryApi.getInventoryAnalyticsOverview']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 集計行IDを参考に子取引を取得する
         * @param {SortType} sortType ソートの種類（asc/desc）
         * @param {number} limit 情報の表示最大数
         * @param {number} offset 表示する情報のオフセット
         * @param {string} aggregateBusinessId 集計取引ID
         * @param {string} earlyPeriod 表示期間のスタート(Date型)
         * @param {string} latterPeriod 表示期間の終わり(Date型)
         * @param {UseFilterItem} [filterItem] フィルター対象の項目と情報
         * @param {string} [getInfoOptions] APIで必要な情報を設定するためのオプション項目。型は文字列型で、カンマ区切りで必要な情報を指定する。指定された情報(数量情報)を取得して返すようにしている。順不同でもOK。
         * @param {ObjectFilterInfo} [filterItemObject] フィルター項目の内、Objectで指定する必要があるもの(単位と値がセットで指定されるもの)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getInventoryBusiness(sortType: SortType, limit: number, offset: number, aggregateBusinessId: string, earlyPeriod: string, latterPeriod: string, filterItem?: UseFilterItem, getInfoOptions?: string, filterItemObject?: ObjectFilterInfo, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetInventoryBusinessSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getInventoryBusiness(sortType, limit, offset, aggregateBusinessId, earlyPeriod, latterPeriod, filterItem, getInfoOptions, filterItemObject, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InventoryApi.getInventoryBusiness']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 集計取引IDに紐づく関連取引の販売実績・内示データを取得する（モーダル表示用）
         * @param {string} aggregateBusinessId 集計取引ID
         * @param {number} startYear 開始年
         * @param {number} startMonth 開始月
         * @param {number} endYear 終了年
         * @param {number} endMonth 終了月
         * @param {number} [receiptMonthOffset] 受領月オフセット（Nヶ月前内示を指定する）
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRelatedTransactionsDetail(aggregateBusinessId: string, startYear: number, startMonth: number, endYear: number, endMonth: number, receiptMonthOffset?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetRelatedTransactionsDetailSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRelatedTransactionsDetail(aggregateBusinessId, startYear, startMonth, endYear, endMonth, receiptMonthOffset, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InventoryApi.getRelatedTransactionsDetail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 在庫テーブルに情報を登録する
         * @param {InventoryPostRequest} inventoryPostRequest 登録する在庫テーブル情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async inventoryPost(inventoryPostRequest: InventoryPostRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PostInventoryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.inventoryPost(inventoryPostRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InventoryApi.inventoryPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * InventoryApi - factory interface
 * @export
 */
export const InventoryApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = InventoryApiFp(configuration)
    return {
        /**
         * 
         * @summary 入荷情報を一括で修正する
         * @param {BulkModifyArrivalRequest} bulkModifyArrivalRequest 修正する在庫情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkModifyArrival(bulkModifyArrivalRequest: BulkModifyArrivalRequest, options?: any): AxiosPromise<BulkModifyArrivalResponse> {
            return localVarFp.bulkModifyArrival(bulkModifyArrivalRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 数値情報を一括で修正する
         * @param {BulkModifyTransactionRequest} bulkModifyTransactionRequest 修正する情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkModifyTransaction(bulkModifyTransactionRequest: BulkModifyTransactionRequest, options?: any): AxiosPromise<SuccessResponse> {
            return localVarFp.bulkModifyTransaction(bulkModifyTransactionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 在庫表の内容をExcelでExportする（テンプレートベース）
         * @param {ExportInventoryExcelRequest} exportInventoryExcelRequest Excelエクスポートのテンプレート設定
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportInventoryBusiness(exportInventoryExcelRequest: ExportInventoryExcelRequest, options?: any): AxiosPromise<ExportInventoryBusinessSuccessResponse> {
            return localVarFp.exportInventoryBusiness(exportInventoryExcelRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 在庫情報を取得する
         * @param {SortType} sortType ソートの種類（asc/desc）
         * @param {number} limit 情報の表示最大数
         * @param {number} offset 表示する情報のオフセット
         * @param {string} earlyPeriod 表示期間のスタート
         * @param {string} latterPeriod 表示期間の終わり
         * @param {string} [sortTarget] ソート対象のカラム名
         * @param {UseFilterItem} [filterItem] フィルター対象の項目と情報
         * @param {string} [getInfoOptions] APIで必要な情報を設定するためのオプション項目。型は文字列型で、カンマ区切りで必要な情報を指定する。指定された情報(数量情報)を取得して返すようにしている。順不同でもOK。
         * @param {ObjectFilterInfo} [filterItemObject] フィルター項目の内、Objectで指定する必要があるもの(単位と値がセットで指定されるもの)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInventory(sortType: SortType, limit: number, offset: number, earlyPeriod: string, latterPeriod: string, sortTarget?: string, filterItem?: UseFilterItem, getInfoOptions?: string, filterItemObject?: ObjectFilterInfo, options?: any): AxiosPromise<GetInventorySuccessResponse> {
            return localVarFp.getInventory(sortType, limit, offset, earlyPeriod, latterPeriod, sortTarget, filterItem, getInfoOptions, filterItemObject, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 在庫分析情報(集計)取得API
         * @param {string} [sortType] ソート向き
         * @param {string} [sortTarget] ソート対象
         * @param {number} [limit] 一度に取得する上限
         * @param {number} [offset] オフセット
         * @param {string} [metricType] 
         * @param {string} [dimensionType] 
         * @param {number} [targetYear] 対象年
         * @param {number} [targetMonth] 対象月
         * @param {number} [targetPeriodFromYear] 対象期間年(from)
         * @param {number} [targetPeriodFromMonth] 対象期間月(from)
         * @param {number} [targetPeriodToYear] 対象期間年(to)
         * @param {number} [targetPeriodToMonth] 対象期間月(to)
         * @param {number} [forecastAccuracyConsiderationMonths] 内示正答率考慮期間
         * @param {UseFilterItem} [filterItem] フィルター対象の項目と情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInventoryAnalyticsByDimensionAggregateBusiness(sortType?: string, sortTarget?: string, limit?: number, offset?: number, metricType?: string, dimensionType?: string, targetYear?: number, targetMonth?: number, targetPeriodFromYear?: number, targetPeriodFromMonth?: number, targetPeriodToYear?: number, targetPeriodToMonth?: number, forecastAccuracyConsiderationMonths?: number, filterItem?: UseFilterItem, options?: any): AxiosPromise<GetInventoryAnalyticsByDimensionAggregateBusinessSuccessInner> {
            return localVarFp.getInventoryAnalyticsByDimensionAggregateBusiness(sortType, sortTarget, limit, offset, metricType, dimensionType, targetYear, targetMonth, targetPeriodFromYear, targetPeriodFromMonth, targetPeriodToYear, targetPeriodToMonth, forecastAccuracyConsiderationMonths, filterItem, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 在庫分析情報(取引)取得API
         * @param {string} [sortType] ソート向き
         * @param {string} [sortTarget] ソート対象
         * @param {number} [limit] 一度に取得する上限
         * @param {number} [offset] オフセット
         * @param {string} [metricType] 
         * @param {string} [dimensionType] 
         * @param {number} [targetYear] 対象年
         * @param {number} [targetMonth] 対象月
         * @param {number} [targetPeriodFromYear] 対象期間年(from)
         * @param {number} [targetPeriodFromMonth] 対象期間月(from)
         * @param {number} [targetPeriodToYear] 対象期間年(to)
         * @param {number} [targetPeriodToMonth] 対象期間月(to)
         * @param {UseFilterItem} [filterItem] フィルター対象の項目と情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInventoryAnalyticsByDimensionBaseBusiness(sortType?: string, sortTarget?: string, limit?: number, offset?: number, metricType?: string, dimensionType?: string, targetYear?: number, targetMonth?: number, targetPeriodFromYear?: number, targetPeriodFromMonth?: number, targetPeriodToYear?: number, targetPeriodToMonth?: number, filterItem?: UseFilterItem, options?: any): AxiosPromise<GetInventoryAnalyticsByDimensionBaseBusinessSuccessInner> {
            return localVarFp.getInventoryAnalyticsByDimensionBaseBusiness(sortType, sortTarget, limit, offset, metricType, dimensionType, targetYear, targetMonth, targetPeriodFromYear, targetPeriodFromMonth, targetPeriodToYear, targetPeriodToMonth, filterItem, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 在庫分析詳細情報(集計)取得API
         * @param {string} [sortType] ソート向き
         * @param {string} [sortTarget] ソート対象
         * @param {number} [limit] 一度に取得する上限
         * @param {number} [offset] オフセット
         * @param {UseFilterItem} [filterItem] フィルター対象の項目と情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInventoryAnalyticsDetailsAggregatebusiness(sortType?: string, sortTarget?: string, limit?: number, offset?: number, filterItem?: UseFilterItem, options?: any): AxiosPromise<GetInventoryAnalyticsDetailAggregateBusinessSuccessInner> {
            return localVarFp.getInventoryAnalyticsDetailsAggregatebusiness(sortType, sortTarget, limit, offset, filterItem, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 在庫分析詳細情報(在庫ゼロ予測の集計)取得API
         * @param {GetInventoryAnalyticsDetailsAggregatebusinessWithAlertSeverityEnum} severity 取得するアラートの重大さ
         * @param {GetInventoryAnalyticsDetailsAggregatebusinessWithAlertDirectionEnum} direction 取得するアラートの向き
         * @param {string} [sortType] ソート向き
         * @param {string} [sortTarget] ソート対象
         * @param {number} [limit] 一度に取得する上限
         * @param {number} [offset] オフセット
         * @param {string} [alertFilterInfo] アラートのフィルタ情報
         * @param {UseFilterItem} [filterItem] フィルター対象の項目と情報
         * @param {string} [excessConsecutiveMonths] 過剰の設定パラメータ
         * @param {string} [excessRatioThreshold] 過剰の設定パラメータ
         * @param {string} [excessMomChangeRateThreshold] 過剰の設定パラメータ
         * @param {string} [excessMinQuantityThreshold] 過剰の設定パラメータ
         * @param {string} [shortageConsecutiveMonths] 不足の設定パラメータ
         * @param {string} [shortageRatioThreshold] 不足の設定パラメータ
         * @param {string} [shortageMomChangeRateThreshold] 不足の設定パラメータ
         * @param {string} [shortageMinQuantityThreshold] 不足の設定パラメータ
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInventoryAnalyticsDetailsAggregatebusinessWithAlert(severity: GetInventoryAnalyticsDetailsAggregatebusinessWithAlertSeverityEnum, direction: GetInventoryAnalyticsDetailsAggregatebusinessWithAlertDirectionEnum, sortType?: string, sortTarget?: string, limit?: number, offset?: number, alertFilterInfo?: string, filterItem?: UseFilterItem, excessConsecutiveMonths?: string, excessRatioThreshold?: string, excessMomChangeRateThreshold?: string, excessMinQuantityThreshold?: string, shortageConsecutiveMonths?: string, shortageRatioThreshold?: string, shortageMomChangeRateThreshold?: string, shortageMinQuantityThreshold?: string, options?: any): AxiosPromise<GetInventoryAnalyticsDetailAggregateBusinessWithAlertSuccessInner> {
            return localVarFp.getInventoryAnalyticsDetailsAggregatebusinessWithAlert(severity, direction, sortType, sortTarget, limit, offset, alertFilterInfo, filterItem, excessConsecutiveMonths, excessRatioThreshold, excessMomChangeRateThreshold, excessMinQuantityThreshold, shortageConsecutiveMonths, shortageRatioThreshold, shortageMomChangeRateThreshold, shortageMinQuantityThreshold, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 在庫分析詳細情報(取引)取得API
         * @param {string} [sortType] ソート向き
         * @param {string} [sortTarget] ソート対象
         * @param {number} [limit] 一度に取得する上限
         * @param {number} [offset] オフセット
         * @param {boolean} [isExcludeNoAccuracy] 内示正答率がない取引を省くかどうか
         * @param {UseFilterItem} [filterItem] フィルター対象の項目と情報
         * @param {string} [forecastForReceiptName] フィルターする受領用内示名
         * @param {string} [forecastForReceiptResponsibleUserId] フィルターする受領用内示担当者ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInventoryAnalyticsDetailsBaseBusiness(sortType?: string, sortTarget?: string, limit?: number, offset?: number, isExcludeNoAccuracy?: boolean, filterItem?: UseFilterItem, forecastForReceiptName?: string, forecastForReceiptResponsibleUserId?: string, options?: any): AxiosPromise<GetInventoryAnalyticsDetailBaseBusinessSuccessInner> {
            return localVarFp.getInventoryAnalyticsDetailsBaseBusiness(sortType, sortTarget, limit, offset, isExcludeNoAccuracy, filterItem, forecastForReceiptName, forecastForReceiptResponsibleUserId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 在庫分析概要情報取得API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInventoryAnalyticsOverview(options?: any): AxiosPromise<GetInventoryAnalyticsOverviewSuccessInner> {
            return localVarFp.getInventoryAnalyticsOverview(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 集計行IDを参考に子取引を取得する
         * @param {SortType} sortType ソートの種類（asc/desc）
         * @param {number} limit 情報の表示最大数
         * @param {number} offset 表示する情報のオフセット
         * @param {string} aggregateBusinessId 集計取引ID
         * @param {string} earlyPeriod 表示期間のスタート(Date型)
         * @param {string} latterPeriod 表示期間の終わり(Date型)
         * @param {UseFilterItem} [filterItem] フィルター対象の項目と情報
         * @param {string} [getInfoOptions] APIで必要な情報を設定するためのオプション項目。型は文字列型で、カンマ区切りで必要な情報を指定する。指定された情報(数量情報)を取得して返すようにしている。順不同でもOK。
         * @param {ObjectFilterInfo} [filterItemObject] フィルター項目の内、Objectで指定する必要があるもの(単位と値がセットで指定されるもの)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInventoryBusiness(sortType: SortType, limit: number, offset: number, aggregateBusinessId: string, earlyPeriod: string, latterPeriod: string, filterItem?: UseFilterItem, getInfoOptions?: string, filterItemObject?: ObjectFilterInfo, options?: any): AxiosPromise<GetInventoryBusinessSuccessResponse> {
            return localVarFp.getInventoryBusiness(sortType, limit, offset, aggregateBusinessId, earlyPeriod, latterPeriod, filterItem, getInfoOptions, filterItemObject, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 集計取引IDに紐づく関連取引の販売実績・内示データを取得する（モーダル表示用）
         * @param {string} aggregateBusinessId 集計取引ID
         * @param {number} startYear 開始年
         * @param {number} startMonth 開始月
         * @param {number} endYear 終了年
         * @param {number} endMonth 終了月
         * @param {number} [receiptMonthOffset] 受領月オフセット（Nヶ月前内示を指定する）
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRelatedTransactionsDetail(aggregateBusinessId: string, startYear: number, startMonth: number, endYear: number, endMonth: number, receiptMonthOffset?: number, options?: any): AxiosPromise<GetRelatedTransactionsDetailSuccessResponse> {
            return localVarFp.getRelatedTransactionsDetail(aggregateBusinessId, startYear, startMonth, endYear, endMonth, receiptMonthOffset, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 在庫テーブルに情報を登録する
         * @param {InventoryPostRequest} inventoryPostRequest 登録する在庫テーブル情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inventoryPost(inventoryPostRequest: InventoryPostRequest, options?: any): AxiosPromise<PostInventoryResponse> {
            return localVarFp.inventoryPost(inventoryPostRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * InventoryApi - object-oriented interface
 * @export
 * @class InventoryApi
 * @extends {BaseAPI}
 */
export class InventoryApi extends BaseAPI {
    /**
     * 
     * @summary 入荷情報を一括で修正する
     * @param {BulkModifyArrivalRequest} bulkModifyArrivalRequest 修正する在庫情報
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InventoryApi
     */
    public bulkModifyArrival(bulkModifyArrivalRequest: BulkModifyArrivalRequest, options?: RawAxiosRequestConfig) {
        return InventoryApiFp(this.configuration).bulkModifyArrival(bulkModifyArrivalRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 数値情報を一括で修正する
     * @param {BulkModifyTransactionRequest} bulkModifyTransactionRequest 修正する情報
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InventoryApi
     */
    public bulkModifyTransaction(bulkModifyTransactionRequest: BulkModifyTransactionRequest, options?: RawAxiosRequestConfig) {
        return InventoryApiFp(this.configuration).bulkModifyTransaction(bulkModifyTransactionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 在庫表の内容をExcelでExportする（テンプレートベース）
     * @param {ExportInventoryExcelRequest} exportInventoryExcelRequest Excelエクスポートのテンプレート設定
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InventoryApi
     */
    public exportInventoryBusiness(exportInventoryExcelRequest: ExportInventoryExcelRequest, options?: RawAxiosRequestConfig) {
        return InventoryApiFp(this.configuration).exportInventoryBusiness(exportInventoryExcelRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 在庫情報を取得する
     * @param {SortType} sortType ソートの種類（asc/desc）
     * @param {number} limit 情報の表示最大数
     * @param {number} offset 表示する情報のオフセット
     * @param {string} earlyPeriod 表示期間のスタート
     * @param {string} latterPeriod 表示期間の終わり
     * @param {string} [sortTarget] ソート対象のカラム名
     * @param {UseFilterItem} [filterItem] フィルター対象の項目と情報
     * @param {string} [getInfoOptions] APIで必要な情報を設定するためのオプション項目。型は文字列型で、カンマ区切りで必要な情報を指定する。指定された情報(数量情報)を取得して返すようにしている。順不同でもOK。
     * @param {ObjectFilterInfo} [filterItemObject] フィルター項目の内、Objectで指定する必要があるもの(単位と値がセットで指定されるもの)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InventoryApi
     */
    public getInventory(sortType: SortType, limit: number, offset: number, earlyPeriod: string, latterPeriod: string, sortTarget?: string, filterItem?: UseFilterItem, getInfoOptions?: string, filterItemObject?: ObjectFilterInfo, options?: RawAxiosRequestConfig) {
        return InventoryApiFp(this.configuration).getInventory(sortType, limit, offset, earlyPeriod, latterPeriod, sortTarget, filterItem, getInfoOptions, filterItemObject, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 在庫分析情報(集計)取得API
     * @param {string} [sortType] ソート向き
     * @param {string} [sortTarget] ソート対象
     * @param {number} [limit] 一度に取得する上限
     * @param {number} [offset] オフセット
     * @param {string} [metricType] 
     * @param {string} [dimensionType] 
     * @param {number} [targetYear] 対象年
     * @param {number} [targetMonth] 対象月
     * @param {number} [targetPeriodFromYear] 対象期間年(from)
     * @param {number} [targetPeriodFromMonth] 対象期間月(from)
     * @param {number} [targetPeriodToYear] 対象期間年(to)
     * @param {number} [targetPeriodToMonth] 対象期間月(to)
     * @param {number} [forecastAccuracyConsiderationMonths] 内示正答率考慮期間
     * @param {UseFilterItem} [filterItem] フィルター対象の項目と情報
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InventoryApi
     */
    public getInventoryAnalyticsByDimensionAggregateBusiness(sortType?: string, sortTarget?: string, limit?: number, offset?: number, metricType?: string, dimensionType?: string, targetYear?: number, targetMonth?: number, targetPeriodFromYear?: number, targetPeriodFromMonth?: number, targetPeriodToYear?: number, targetPeriodToMonth?: number, forecastAccuracyConsiderationMonths?: number, filterItem?: UseFilterItem, options?: RawAxiosRequestConfig) {
        return InventoryApiFp(this.configuration).getInventoryAnalyticsByDimensionAggregateBusiness(sortType, sortTarget, limit, offset, metricType, dimensionType, targetYear, targetMonth, targetPeriodFromYear, targetPeriodFromMonth, targetPeriodToYear, targetPeriodToMonth, forecastAccuracyConsiderationMonths, filterItem, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 在庫分析情報(取引)取得API
     * @param {string} [sortType] ソート向き
     * @param {string} [sortTarget] ソート対象
     * @param {number} [limit] 一度に取得する上限
     * @param {number} [offset] オフセット
     * @param {string} [metricType] 
     * @param {string} [dimensionType] 
     * @param {number} [targetYear] 対象年
     * @param {number} [targetMonth] 対象月
     * @param {number} [targetPeriodFromYear] 対象期間年(from)
     * @param {number} [targetPeriodFromMonth] 対象期間月(from)
     * @param {number} [targetPeriodToYear] 対象期間年(to)
     * @param {number} [targetPeriodToMonth] 対象期間月(to)
     * @param {UseFilterItem} [filterItem] フィルター対象の項目と情報
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InventoryApi
     */
    public getInventoryAnalyticsByDimensionBaseBusiness(sortType?: string, sortTarget?: string, limit?: number, offset?: number, metricType?: string, dimensionType?: string, targetYear?: number, targetMonth?: number, targetPeriodFromYear?: number, targetPeriodFromMonth?: number, targetPeriodToYear?: number, targetPeriodToMonth?: number, filterItem?: UseFilterItem, options?: RawAxiosRequestConfig) {
        return InventoryApiFp(this.configuration).getInventoryAnalyticsByDimensionBaseBusiness(sortType, sortTarget, limit, offset, metricType, dimensionType, targetYear, targetMonth, targetPeriodFromYear, targetPeriodFromMonth, targetPeriodToYear, targetPeriodToMonth, filterItem, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 在庫分析詳細情報(集計)取得API
     * @param {string} [sortType] ソート向き
     * @param {string} [sortTarget] ソート対象
     * @param {number} [limit] 一度に取得する上限
     * @param {number} [offset] オフセット
     * @param {UseFilterItem} [filterItem] フィルター対象の項目と情報
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InventoryApi
     */
    public getInventoryAnalyticsDetailsAggregatebusiness(sortType?: string, sortTarget?: string, limit?: number, offset?: number, filterItem?: UseFilterItem, options?: RawAxiosRequestConfig) {
        return InventoryApiFp(this.configuration).getInventoryAnalyticsDetailsAggregatebusiness(sortType, sortTarget, limit, offset, filterItem, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 在庫分析詳細情報(在庫ゼロ予測の集計)取得API
     * @param {GetInventoryAnalyticsDetailsAggregatebusinessWithAlertSeverityEnum} severity 取得するアラートの重大さ
     * @param {GetInventoryAnalyticsDetailsAggregatebusinessWithAlertDirectionEnum} direction 取得するアラートの向き
     * @param {string} [sortType] ソート向き
     * @param {string} [sortTarget] ソート対象
     * @param {number} [limit] 一度に取得する上限
     * @param {number} [offset] オフセット
     * @param {string} [alertFilterInfo] アラートのフィルタ情報
     * @param {UseFilterItem} [filterItem] フィルター対象の項目と情報
     * @param {string} [excessConsecutiveMonths] 過剰の設定パラメータ
     * @param {string} [excessRatioThreshold] 過剰の設定パラメータ
     * @param {string} [excessMomChangeRateThreshold] 過剰の設定パラメータ
     * @param {string} [excessMinQuantityThreshold] 過剰の設定パラメータ
     * @param {string} [shortageConsecutiveMonths] 不足の設定パラメータ
     * @param {string} [shortageRatioThreshold] 不足の設定パラメータ
     * @param {string} [shortageMomChangeRateThreshold] 不足の設定パラメータ
     * @param {string} [shortageMinQuantityThreshold] 不足の設定パラメータ
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InventoryApi
     */
    public getInventoryAnalyticsDetailsAggregatebusinessWithAlert(severity: GetInventoryAnalyticsDetailsAggregatebusinessWithAlertSeverityEnum, direction: GetInventoryAnalyticsDetailsAggregatebusinessWithAlertDirectionEnum, sortType?: string, sortTarget?: string, limit?: number, offset?: number, alertFilterInfo?: string, filterItem?: UseFilterItem, excessConsecutiveMonths?: string, excessRatioThreshold?: string, excessMomChangeRateThreshold?: string, excessMinQuantityThreshold?: string, shortageConsecutiveMonths?: string, shortageRatioThreshold?: string, shortageMomChangeRateThreshold?: string, shortageMinQuantityThreshold?: string, options?: RawAxiosRequestConfig) {
        return InventoryApiFp(this.configuration).getInventoryAnalyticsDetailsAggregatebusinessWithAlert(severity, direction, sortType, sortTarget, limit, offset, alertFilterInfo, filterItem, excessConsecutiveMonths, excessRatioThreshold, excessMomChangeRateThreshold, excessMinQuantityThreshold, shortageConsecutiveMonths, shortageRatioThreshold, shortageMomChangeRateThreshold, shortageMinQuantityThreshold, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 在庫分析詳細情報(取引)取得API
     * @param {string} [sortType] ソート向き
     * @param {string} [sortTarget] ソート対象
     * @param {number} [limit] 一度に取得する上限
     * @param {number} [offset] オフセット
     * @param {boolean} [isExcludeNoAccuracy] 内示正答率がない取引を省くかどうか
     * @param {UseFilterItem} [filterItem] フィルター対象の項目と情報
     * @param {string} [forecastForReceiptName] フィルターする受領用内示名
     * @param {string} [forecastForReceiptResponsibleUserId] フィルターする受領用内示担当者ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InventoryApi
     */
    public getInventoryAnalyticsDetailsBaseBusiness(sortType?: string, sortTarget?: string, limit?: number, offset?: number, isExcludeNoAccuracy?: boolean, filterItem?: UseFilterItem, forecastForReceiptName?: string, forecastForReceiptResponsibleUserId?: string, options?: RawAxiosRequestConfig) {
        return InventoryApiFp(this.configuration).getInventoryAnalyticsDetailsBaseBusiness(sortType, sortTarget, limit, offset, isExcludeNoAccuracy, filterItem, forecastForReceiptName, forecastForReceiptResponsibleUserId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 在庫分析概要情報取得API
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InventoryApi
     */
    public getInventoryAnalyticsOverview(options?: RawAxiosRequestConfig) {
        return InventoryApiFp(this.configuration).getInventoryAnalyticsOverview(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 集計行IDを参考に子取引を取得する
     * @param {SortType} sortType ソートの種類（asc/desc）
     * @param {number} limit 情報の表示最大数
     * @param {number} offset 表示する情報のオフセット
     * @param {string} aggregateBusinessId 集計取引ID
     * @param {string} earlyPeriod 表示期間のスタート(Date型)
     * @param {string} latterPeriod 表示期間の終わり(Date型)
     * @param {UseFilterItem} [filterItem] フィルター対象の項目と情報
     * @param {string} [getInfoOptions] APIで必要な情報を設定するためのオプション項目。型は文字列型で、カンマ区切りで必要な情報を指定する。指定された情報(数量情報)を取得して返すようにしている。順不同でもOK。
     * @param {ObjectFilterInfo} [filterItemObject] フィルター項目の内、Objectで指定する必要があるもの(単位と値がセットで指定されるもの)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InventoryApi
     */
    public getInventoryBusiness(sortType: SortType, limit: number, offset: number, aggregateBusinessId: string, earlyPeriod: string, latterPeriod: string, filterItem?: UseFilterItem, getInfoOptions?: string, filterItemObject?: ObjectFilterInfo, options?: RawAxiosRequestConfig) {
        return InventoryApiFp(this.configuration).getInventoryBusiness(sortType, limit, offset, aggregateBusinessId, earlyPeriod, latterPeriod, filterItem, getInfoOptions, filterItemObject, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 集計取引IDに紐づく関連取引の販売実績・内示データを取得する（モーダル表示用）
     * @param {string} aggregateBusinessId 集計取引ID
     * @param {number} startYear 開始年
     * @param {number} startMonth 開始月
     * @param {number} endYear 終了年
     * @param {number} endMonth 終了月
     * @param {number} [receiptMonthOffset] 受領月オフセット（Nヶ月前内示を指定する）
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InventoryApi
     */
    public getRelatedTransactionsDetail(aggregateBusinessId: string, startYear: number, startMonth: number, endYear: number, endMonth: number, receiptMonthOffset?: number, options?: RawAxiosRequestConfig) {
        return InventoryApiFp(this.configuration).getRelatedTransactionsDetail(aggregateBusinessId, startYear, startMonth, endYear, endMonth, receiptMonthOffset, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 在庫テーブルに情報を登録する
     * @param {InventoryPostRequest} inventoryPostRequest 登録する在庫テーブル情報
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InventoryApi
     */
    public inventoryPost(inventoryPostRequest: InventoryPostRequest, options?: RawAxiosRequestConfig) {
        return InventoryApiFp(this.configuration).inventoryPost(inventoryPostRequest, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const GetInventoryAnalyticsDetailsAggregatebusinessWithAlertSeverityEnum = {
    Critical: 'critical',
    Warning: 'warning'
} as const;
export type GetInventoryAnalyticsDetailsAggregatebusinessWithAlertSeverityEnum = typeof GetInventoryAnalyticsDetailsAggregatebusinessWithAlertSeverityEnum[keyof typeof GetInventoryAnalyticsDetailsAggregatebusinessWithAlertSeverityEnum];
/**
 * @export
 */
export const GetInventoryAnalyticsDetailsAggregatebusinessWithAlertDirectionEnum = {
    Excess: 'excess',
    Shortage: 'shortage'
} as const;
export type GetInventoryAnalyticsDetailsAggregatebusinessWithAlertDirectionEnum = typeof GetInventoryAnalyticsDetailsAggregatebusinessWithAlertDirectionEnum[keyof typeof GetInventoryAnalyticsDetailsAggregatebusinessWithAlertDirectionEnum];


